import Phaser from "phaser";
import AudioManager from "../../../@shared/utils/AudioManager";
import cityBVoidPng from "../../../@shared/assets/GameMaps/tilesets/city/FDR_City_B_VOID.png";
import cityCVoidPng from "../../../@shared/assets/GameMaps/tilesets/city/FDR_City_C_Void.png";
import cityDVoidPng from "../../../@shared/assets/GameMaps/tilesets/city/FDR_City_D_VOID.png";
import cityEVoidPng from "../../../@shared/assets/GameMaps/tilesets/city/FDR_City_E_VOID.png";
import cityTemplatePng from "../../../@shared/assets/GameMaps/tilesets/city/voidcity2-0-template.png";
import customVoidBuildingsPng from "../../../@shared/assets/GameMaps/tilesets/city/voidcitybuildings.png";
import whisperingGrassPng from "../../../@shared/assets/GameMaps/tilesets/forest/TX Tileset Grass.png";
import whisperingPlantPng from "../../../@shared/assets/GameMaps/tilesets/forest/TX Plant.png";
import afroChickPortraitPng from "../../../@shared/assets/npcs/afro-chick.png";
import clergyWomanPortraitPng from "../../../@shared/assets/npcs/clergy-woman.png";
import elderPortraitPng from "../../../@shared/assets/npcs/elder1.png";
import cityNpc1Png from "../../../@shared/assets/npcs/spritesheets/FD_Character_001.png";
import cityNpc1IdlePng from "../../../@shared/assets/npcs/spritesheets/FD_Character_001_Idle.png";
import cityNpc2Png from "../../../@shared/assets/npcs/spritesheets/FD_Character_002.png";
import cityNpc2IdlePng from "../../../@shared/assets/npcs/spritesheets/FD_Character_002_Idle.png";
import cityNpc3Png from "../../../@shared/assets/npcs/spritesheets/FD_Character_003.png";
import cityNpc3IdlePng from "../../../@shared/assets/npcs/spritesheets/FD_Character_003_Idle.png";
import cityNpc4Png from "../../../@shared/assets/npcs/spritesheets/FD_Character_007.png";
import cityNpc4IdlePng from "../../../@shared/assets/npcs/spritesheets/FD_Character_007_Idle.png";
import cityNpc5Png from "../../../@shared/assets/npcs/spritesheets/FD_Character_016.png";
import cityNpc5IdlePng from "../../../@shared/assets/npcs/spritesheets/FD_Character_016_Idle.png";
import toughGuyPortraitPng from "../../../@shared/assets/npcs/tough-guy.png";
import arenaSignPng from "./arena-sign.png";
import merchantSignPng from "./merchant-sign.png";
import decksmithSignPng from "./decksmith-sign.png";
import questMasterSignPng from "./questMaster-sign.png";
import voidCity2Source from "./voidcity2-source.json";
import {
  getAvatarSpriteConfig,
  getAvatarFrameForDirection,
  normalizeAvatarName,
  scaleAvatarBodySize,
  SPRITES_MAP,
} from "../../../@shared/utils/SpritesMap";
import { createWalkAnimations, preloadAvatars } from "../../../@shared/utils/SceneHelpers";
import {
  createLocalOrbAvatarImage,
  getLocalOrbAvatarConfig,
  ORB_RENDER_SIZE,
  preloadLocalOrbAvatar,
  updateLocalOrbAvatar,
} from "../../../@shared/utils/phaserOrbAvatar";
import { createOrbTextureKey, resolveAvatarData } from "../../../@shared/utils/orbAvatar";
import {
  createStoryCompanionFollower,
  destroyStoryCompanionFollower,
  syncStoryCompanionFollower,
} from "../../../@shared/utils/storyCompanionFollower";
import {
  getStoryCreatureCard,
  STORY_CREATURE_CARDS,
} from "../../../@shared/utils/storyCreatures";
import { useAuthStore } from "../../../@shared/store/useAuthStore";
import { useStoryStore } from "../../../@shared/store/useStoryStore";
import { updatePlayerPresence } from "../../../@shared/utils/roomFunctions";
import { getVoidCityExteriorReturnSpawnByDoorId } from "../../../@shared/utils/voidCityDoorSpawns";
import {
  WHISPERING_FOREST_PORTAL,
  WHISPERING_FOREST_PORTAL_RETURN_SPAWN,
} from "../../../@shared/utils/voidCityStoryPortalSpawns";
import { applyWorldSceneBackground } from "../../../@shared/utils/worldSceneBackgrounds";
import { STORY_WORLD_ENCOUNTER_RELEASE_EVENT } from "../../../@shared/utils/storyWorldEncounterContext";
import { WHISPERING_FOREST_STORY_PACK_CHEST_MODE } from "../whisperingForest/storyPackChests";

const DOOR_SFX = require("../../../@shared/assets/sounds/door.mp3");

const TILE_SIZE = 32;
const MAP_WIDTH = 1600;
const MAP_HEIGHT = 1984;
const NPC_FRAME_SIZE = 24;
const NPC_MOVE_SPEED = 0.38;
const NPC_WAIT_MS = 1800;
const NPC_SCALE = 2.35;
const DOOR_CLOSED_FRAME = 31;
const ARENA_DOOR_ID = "door-40-31";
const MERCHANT_DOOR_ID = "door-2-33";
const DECKSMITH_DOOR_ID = "door-18-33";
const GAME_HALL_DOOR_ID = "door-28-17";
const QUESTMASTER_DOOR_ID = "door-21-49";
const STORY_COMPANION_TRIGGER_ID = "arena-exit-io";
const STORY_GLYDE_TRIGGER_ID = "city-grove-glyde";
const STORY_GLYDE_MISSION_ID = "act-1-mission-11";
const WHISPERING_FOREST_PORTAL_LABEL = "whisperingForestPortal";
const PLAYER_DEPTH = 2000;
const ORB_COLLISION_RADIUS = 20;
const ORB_COLLISION_Y_SCALE = 2.0;
const HUMAN_COLLISION_SIZE = { width: 72, height: 132 };
const STORY_ENCOUNTER_SCALE = 1.3;
const STORY_ENCOUNTER_SHADOW_ALPHA = 0.24;
const STORY_ENCOUNTER_LABEL_OFFSET_Y = 34;
const STORY_CREATURE_FRAMES_PER_ROW = 4;
const STORY_CREATURE_ANIMATION_FRAME_RATE = 7;
const STORY_CREATURE_ANIMATION_ROWS = Object.freeze({
  down: 0,
  left: 1,
  right: 2,
  up: 3,
  dead: 4,
});
const STORY_ENCOUNTER_IDLE_WAIT_MS = 900;
const CITY_TREE_BASE_DEPTH = 2300;
const CITY_PROP_DEPTH = 2600;
const CITY_AMBIENT_PARTICLE_DEPTH = 1580;
const ENABLE_VOID_CITY_2_EXITS = false;
const ENABLE_VOID_CITY_2_BUILDING_DOORS = true;
const STORY_GLYDE_TRIGGER_GROVE_BOUNDS = Object.freeze({
  left: WHISPERING_FOREST_PORTAL.x - 256,
  top: WHISPERING_FOREST_PORTAL.y - 48,
  width: 416,
  height: 544,
});
const BUILDING_EXIT_SPAWN_Y_OFFSET = 42;
const REMOTE_PLAYER_NAME_OFFSET_Y = 50;
const TREE_SWAY_SETTINGS = {
  large: { bob: 2.2, duration: 3000 },
  medium: { bob: 1.8, duration: 2700 },
  small: { bob: 1.15, duration: 2600 },
};
const STORY_WORLD_TRIGGER_ZONES = Object.freeze({
  [STORY_COMPANION_TRIGGER_ID]: Object.freeze({
    x: 1296,
    y: 1066,
    width: 176,
    height: 168,
  }),
  // Matter rectangles use center coordinates. We derive this from grove bounds near the
  // Whispering Forest portal so Mission 11 triggers deep enough into the park area.
  [STORY_GLYDE_TRIGGER_ID]: Object.freeze({
    x:
      STORY_GLYDE_TRIGGER_GROVE_BOUNDS.left
      + STORY_GLYDE_TRIGGER_GROVE_BOUNDS.width / 2,
    y:
      STORY_GLYDE_TRIGGER_GROVE_BOUNDS.top
      + STORY_GLYDE_TRIGGER_GROVE_BOUNDS.height / 2,
    width: STORY_GLYDE_TRIGGER_GROVE_BOUNDS.width,
    height: STORY_GLYDE_TRIGGER_GROVE_BOUNDS.height,
  }),
});
const STORY_GLYDE_KEY = "vc2StoryGlyde";
const STORY_GLYDE_ANIMATION_PREFIX = "story-glyde";
const STORY_GLYDE_ENTRY_POSITION = Object.freeze({
  x: WHISPERING_FOREST_PORTAL.x + WHISPERING_FOREST_PORTAL.width / 2 - 10,
  y: WHISPERING_FOREST_PORTAL.y + WHISPERING_FOREST_PORTAL.height / 2 + 18,
});
const STORY_GLYDE_EXIT_POSITION = Object.freeze({ x: 1120, y: 1568 });
const STORY_GLYDE_APPROACH_OFFSET = Object.freeze({ x: 96, y: 18 });
const STORY_GLYDE_IDLE_DIRECTION = 270;
const readStoryMissionEncounterRuntime = () =>
  typeof window !== "undefined" ? window.__storyMissionEncounterRuntime || null : null;
const getStoryCreatureTextureKey = (creatureId = "") =>
  `vc2-story-creature-${String(creatureId || "").trim().toLowerCase()}`;
const getStoryCreatureAnimationKey = (creatureId = "", animationName = "down") =>
  `${getStoryCreatureTextureKey(creatureId)}:${animationName}`;

  const buildWhisperingForestLockedScript = () => [
    {
      speaker: { name: "Infinity Orb" },
      text: "The Whispering Forest can wait. Let's finish the story beat in front of us first.",
    },
  ];

const getWhisperingForestPortalBounds = () =>
  new Phaser.Geom.Rectangle(
    WHISPERING_FOREST_PORTAL.x,
    WHISPERING_FOREST_PORTAL.y,
    WHISPERING_FOREST_PORTAL.width,
    WHISPERING_FOREST_PORTAL.height,
  );

const destroyRemotePlayerVisual = (entry) => {
  entry?.sprite?.destroy?.();
  entry?.orbImage?.destroy?.();
  entry?.nameTag?.destroy?.();
  entry?.nameTagBg?.destroy?.();
};

const TREE_TEXTURE_RECTS = {
  large: { x: 24, y: 14, width: 113, height: 139 },
  medium: { x: 161, y: 17, width: 96, height: 136 },
  small: { x: 295, y: 31, width: 79, height: 120 },
};

const TREE_PIVOT_POINTS = {
  large: { x: 54, y: 122 },
  medium: { x: 46, y: 121 },
  small: { x: 38, y: 106 },
};

const TREE_LOCKED_BASE_HEIGHT = {
  large: 14,
  medium: 14,
  small: 20,
};
const TREE_COLLISION_SPECS = {
  large: { width: 36, height: 40 },
  medium: { width: 28, height: 38 },
  small: { width: 22, height: 34 },
};

const TREE_PREVIEW_PATTERNS = [
  { kind: "large", localOffset: 0, widthTiles: 5, heightTiles: 6 },
  { kind: "medium", localOffset: 5, widthTiles: 3, heightTiles: 5 },
  { kind: "small", localOffset: 9, widthTiles: 3, heightTiles: 5 },
];
const TREE_PREVIEW_TILESET_COLUMNS = 16;
const RENDERABLE_SOURCE_LAYER_NAMES = Object.freeze([
  "Grass",
  "Sidewalks",
  "Roads",
  "Rails",
  "Rails2",
  "Buildings",
  "CustomBuildings",
  "Windows",
  "Signs",
]);

const CITY_NPC_PATROLS = [
  {
    key: "vc2NpcCourier",
    texture: "vc2NpcCourier",
    idleTexture: "vc2NpcCourierIdle",
    promptLabel: "Talk To Orin",
    displayName: "Orin",
    portrait: elderPortraitPng,
    speech: "South block stays busy. Keep your eyes on the crossings.",
    dialogueLines: [
      "South block stays busy. Keep your eyes on the crossings.",
      "The south lane gets hectic whenever the arena crowd starts moving again.",
      "A steady pace keeps you out of trouble better than a fast one does.",
    ],
    start: { x: 688, y: 720 },
    path: [{ x: 688, y: 720 }, { x: 1168, y: 720 }],
  },
  {
    key: "vc2NpcResident",
    texture: "vc2NpcResident",
    idleTexture: "vc2NpcResidentIdle",
    promptLabel: "Talk To Knox",
    displayName: "Knox",
    portrait: toughGuyPortraitPng,
    speech: "The trees make this side of Void City feel calmer than it looks.",
    dialogueLines: [
      "The trees make this side of Void City feel calmer than it looks.",
      "You get enough steel and stone in your day, a little shade starts to matter.",
      "Stick around long enough and you learn which corners are loud and which ones let you breathe.",
    ],
    start: { x: 1296, y: 336 },
    path: [{ x: 1296, y: 336 }, { x: 1296, y: 720 }],
  },
  {
    key: "vc2NpcVisitor",
    texture: "vc2NpcVisitor",
    idleTexture: "vc2NpcVisitorIdle",
    promptLabel: "Talk To Zuri",
    displayName: "Zuri",
    portrait: afroChickPortraitPng,
    speech: "Merchant Row has what you need if you know where to look.",
    dialogueLines: [
      "Merchant Row has what you need if you know where to look.",
      "The best stalls never shout. You spot them by the crowd that pretends not to be waiting.",
      "If you are after something rare, make one pass, then come back later and ask again.",
    ],
    start: { x: 464, y: 1296 },
    path: [{ x: 464, y: 1296 }, { x: 944, y: 1296 }],
  },
  {
    key: "vc2NpcVendor",
    texture: "vc2NpcVendor",
    idleTexture: "vc2NpcVendorIdle",
    promptLabel: "Talk To Imani",
    displayName: "Imani",
    portrait: clergyWomanPortraitPng,
    speech: "Quest Hall traffic picks up whenever the arena crowd spills out.",
    dialogueLines: [
      "Quest Hall traffic picks up whenever the arena crowd spills out.",
      "A victory sends people looking for work, and a loss sends them looking for meaning.",
      "Either way, the hall stays full after the arena doors swing open.",
    ],
    start: { x: 272, y: 1776 },
    path: [{ x: 272, y: 1776 }, { x: 944, y: 1776 }],
  },
];

function buildNpcDialogueScript(npc) {
  const speaker = {
    name: npc.displayName || npc.promptLabel?.replace(/^Talk To /, "") || "Citizen",
    portrait: npc.portrait || null,
  };
  const dialogueLines = npc.dialogueLines?.length
    ? npc.dialogueLines
    : [npc.speech || "Nice day for a walk through Void City."];
  const selectedLine = Phaser.Utils.Array.GetRandom(dialogueLines);

  return [{
    speaker,
    text: selectedLine,
  }];
}

const CITY_PROP_SPECS = [
  { frame: 56, x: 736, y: 576, tag: "lamp" },
  { frame: 59, x: 1088, y: 576, tag: "lamp" },
  { frame: 56, x: 512, y: 1600, tag: "lamp" },
  { frame: 59, x: 864, y: 1600, tag: "lamp" },
  { frame: 56, x: 1120, y: 1056, tag: "lamp" },
  { frame: 59, x: 1440, y: 1056, tag: "lamp" },
  { frame: 96, x: 992, y: 160, tag: "kiosk" },
];

const CITY_TREE_SPECS = [
  { kind: "small", x: 52, y: 1468 },
  { kind: "medium", x: 86, y: 1576 },
  { kind: "small", x: 152, y: 1460 },
  { kind: "small", x: 1248, y: 800 },
  { kind: "small", x: 1450, y: 796 },
  { kind: "medium", x: 1336, y: 896 },
  { kind: "small", x: 1232, y: 984 },
  { kind: "small", x: 1470, y: 968 },
  { kind: "medium", x: 1322, y: 1084 },
  { kind: "small", x: 1500, y: 1118 },
  { kind: "small", x: 1218, y: 1206 },
  { kind: "medium", x: 1386, y: 1278 },
  { kind: "small", x: 1502, y: 1308 },
  { kind: "small", x: 1268, y: 1446 },
  { kind: "medium", x: 1450, y: 1498 },
  { kind: "small", x: 1318, y: 1644 },
  { kind: "small", x: 1490, y: 1692 },
];

const TARGET_COLORS = {
  road: { r: 61, g: 28, b: 79 },
  grass: { r: 109, g: 151, b: 9 },
  sidewalk: { r: 162, g: 114, b: 149 },
  white: { r: 232, g: 220, b: 236 },
  yellow: { r: 243, g: 225, b: 34 },
};

const BASE_FRAMES = {
  grass: 3,
  sidewalk: 67,
  road: 179,
};

const SIDEWALK_OVERRIDE_RECTS = [
  { x: 640, y: 0, width: 448, height: 224 },
  { x: 1248, y: 0, width: 352, height: 224 },
  { x: 0, y: 736, width: 288, height: 704 },
  { x: 704, y: 320, width: 416, height: 160 },
  { x: 1248, y: 320, width: 352, height: 416 },
  { x: 448, y: 704, width: 736, height: 352 },
  { x: 448, y: 1120, width: 544, height: 448 },
];

const ROAD_CLEANUP_RECTS = [
  // Left-side road corridor beside the central green block.
  { x: 544, y: 224, width: 96, height: 1408 },
  // Right-side road corridor beside the top-right/central-right block.
  { x: 1184, y: 224, width: 64, height: 1184 },
];

const SIMPLE_BUILDING_FRAMES = {
  roof: [
    [80, 81, 82],
    [96, 97, 98],
    [112, 113, 114],
  ],
  base: [
    [128, 129, 130],
    [144, 145, 146],
  ],
};

const TEST_BUILDING = {
  id: "top-right-test-building",
  x: 1280,
  y: 416,
  widthTiles: 5,
  roofRows: 3,
  baseRows: 2,
};

const SIMPLE_BUILDINGS = [
  TEST_BUILDING,
  {
    id: "north-market-building",
    x: 704,
    y: 352,
    widthTiles: 14,
    roofRows: 4,
    baseRows: 3,
  },
  {
    id: "south-plaza-building",
    x: 480,
    y: 1376,
    widthTiles: 13,
    roofRows: 4,
    baseRows: 3,
  },
];

const CUSTOM_BUILDINGS = [
  {
    id: "east-custom-building",
    x: 1088,
    y: 768,
    sourceX: 0,
    sourceY: 0,
    width: 416,
    height: 320,
    collisions: [
      { x: 64, y: 224, width: 128, height: 96 },
      { x: 352, y: 224, width: 128, height: 96 },
      { x: 208, y: 112, width: 128, height: 160 },
    ],
  },
  {
    id: "south-east-custom-building",
    x: 32,
    y: 1120,
    sourceX: 0,
    sourceY: 1056,
    width: 288,
    height: 480,
    collisions: [
      { x: 144, y: 392, width: 192, height: 128 },
      { x: 144, y: 248, width: 128, height: 128 },
    ],
  },
  {
    id: "north-center-custom-building",
    x: 672,
    y: 32,
    sourceX: 544,
    sourceY: 128,
    width: 416,
    height: 192,
    collisions: [
      { x: 208, y: 136, width: 288, height: 96 },
      { x: 208, y: 72, width: 128, height: 64 },
    ],
  },
  {
    id: "central-custom-building",
    x: 768,
    y: 800,
    sourceX: 1088,
    sourceY: 32,
    width: 288,
    height: 288,
    collisions: [
      { x: 144, y: 216, width: 192, height: 96 },
      { x: 144, y: 112, width: 128, height: 96 },
    ],
  },
  {
    id: "central-left-custom-building",
    x: 480,
    y: 800,
    sourceX: 768,
    sourceY: 544,
    width: 224,
    height: 288,
    collisions: [
      { x: 112, y: 220, width: 160, height: 104 },
      { x: 112, y: 116, width: 96, height: 96 },
    ],
  },
];

const FACADE_FRAMES = {
  doorSequence: [31, 63, 95, 127],
  doorFrameTop: [0, 1, 2],
  doorFrameBottom: [16, 17, 18],
  windowSingle: 13,
};

const BUILDING_FACADES = {
  "top-right-test-building": {
    door: { x: 1280 + 3 * TILE_SIZE, y: 416 + 4 * TILE_SIZE },
    window: { x: 1280 + TILE_SIZE, y: 416 + 3 * TILE_SIZE },
  },
  "north-market-building": {
    door: { x: 704 + 6 * TILE_SIZE, y: 352 + 6 * TILE_SIZE },
    window: { x: 704 + 3 * TILE_SIZE, y: 352 + 5 * TILE_SIZE },
  },
  "south-plaza-building": {
    door: { x: 480 + 6 * TILE_SIZE, y: 1376 + 6 * TILE_SIZE },
    window: { x: 480 + 3 * TILE_SIZE, y: 1376 + 5 * TILE_SIZE },
  },
  "east-custom-building": {
    door: { x: 1088 + 6 * TILE_SIZE, y: 768 + 7 * TILE_SIZE },
  },
  "south-east-custom-building": {
    door: { x: 32 + 4 * TILE_SIZE, y: 1120 + 14 * TILE_SIZE },
  },
  "north-center-custom-building": {
    door: { x: 672 + 6 * TILE_SIZE, y: 32 + 5 * TILE_SIZE },
  },
  "central-custom-building": {
    door: { x: 768 + 4 * TILE_SIZE, y: 800 + 8 * TILE_SIZE },
  },
  "central-left-custom-building": {
    door: { x: 480 + 3 * TILE_SIZE, y: 800 + 8 * TILE_SIZE },
  },
};

function colorDistanceSq(color, target) {
  return (
    (color.r - target.r) ** 2
    + (color.g - target.g) ** 2
    + (color.b - target.b) ** 2
  );
}

export default class VoidCity2Scene extends Phaser.Scene {
  constructor() {
    super({ key: "VoidCity2Scene" });
  }

  init(data = {}) {
    const fallbackUserData = useAuthStore.getState().userData || null;
    const bootUserData = data.userData || fallbackUserData;
    const resolvedAvatarKey = normalizeAvatarName(
      data.heroAvatarKey || bootUserData?.avatar?.name || "io_default",
    );

    this.spawnPoint = data.spawn || { x: 448, y: 1088 };
    this.returnSpawn = data.returnSpawn || { x: 980, y: 560 };
    this.heroUrl =
      data.heroUrl ||
      SPRITES_MAP[resolvedAvatarKey] ||
      SPRITES_MAP.io_default ||
      null;
    this.heroAvatarKey = resolvedAvatarKey;
    this.heroSpriteConfig = getAvatarSpriteConfig(this.heroAvatarKey);
    this.userData = bootUserData;
    const { avatarData, textureKey } = getLocalOrbAvatarConfig(this.userData);
    this.localOrbAvatarData = avatarData;
    this.localOrbTextureKey = textureKey;
  }

  getActiveStoryWorldTarget() {
    const storyStore = useStoryStore.getState();
    const target =
      (typeof window !== "undefined" ? window.__storyLaunchTarget : null) ||
      storyStore?.currentLaunchTarget ||
      storyStore?.progress?.currentLaunchTarget ||
      null;

    if (target?.kind !== "world") {
      if (storyStore?.currentMissionId === STORY_GLYDE_MISSION_ID) {
        return {
          kind: "world",
          missionId: STORY_GLYDE_MISSION_ID,
          stepId: `${STORY_GLYDE_MISSION_ID}:debug-fallback`,
          triggerSceneKey: this.scene.key,
          triggerZoneId: STORY_GLYDE_TRIGGER_ID,
          resolveMode: "after_script",
        };
      }

      return null;
    }

    if (
      String(target?.triggerSceneKey || "").trim().toLowerCase() !==
      this.scene.key.toLowerCase()
    ) {
      return null;
    }

    return target;
  }

  destroyStoryWorldTriggerSensor() {
    if (this.storyWorldTriggerSensor) {
      try {
        this.matter?.world?.remove?.(this.storyWorldTriggerSensor);
      } catch {}
    }

    this.storyWorldTriggerSensor = null;
    this.storyWorldTriggerBounds = null;
    this.storyWorldTriggerKey = "";
  }

  fireStoryWorldTrigger(triggerZoneId = "") {
    const activeTarget = this.getActiveStoryWorldTarget();
    if (!activeTarget) return;
    if (String(activeTarget?.triggerZoneId || "") !== String(triggerZoneId || "")) return;

    const firedKey = `${activeTarget.stepId || "world"}:${triggerZoneId}`;
    if (this.storyWorldTriggerFiredKey === firedKey) return;
    this.storyWorldTriggerFiredKey = firedKey;

    this.currentDoor = null;
    this.currentNpc = null;
    console.log("[StoryWorld] trigger fired", {
      missionId: activeTarget.missionId,
      sceneKey: this.scene.key,
      triggerZoneId,
    });
    window.dispatchEvent(new CustomEvent("npc-proximity", { detail: null }));
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    window.dispatchEvent(new CustomEvent("interact-proximity", { detail: false }));
    window.dispatchEvent(
      new CustomEvent("story-world-trigger", {
        detail: {
          missionId: activeTarget.missionId,
          sceneKey: this.scene.key,
          triggerZoneId,
        },
      }),
    );

    if (triggerZoneId === STORY_GLYDE_TRIGGER_ID) {
      window.dispatchEvent(
        new CustomEvent("story-scene-cue", {
          detail: {
            missionId: activeTarget.missionId,
            cue: { id: "glyde-enter" },
            lineIndex: -1,
          },
        }),
      );
    }
  }

  syncStoryWorldTriggerSensor() {
    const activeTarget = this.getActiveStoryWorldTarget();
    const triggerZoneId = activeTarget?.triggerZoneId || "";
    const triggerZone = STORY_WORLD_TRIGGER_ZONES[triggerZoneId] || null;
    const desiredKey =
      activeTarget && triggerZone
        ? `${activeTarget.stepId || "world"}:${triggerZoneId}`
        : "";

    if (desiredKey === this.storyWorldTriggerKey) {
      if (
        desiredKey &&
        this.storyWorldTriggerBounds &&
        this.player &&
        Phaser.Geom.Rectangle.Contains(
          this.storyWorldTriggerBounds,
          this.player.x,
          this.player.y,
        )
      ) {
        this.fireStoryWorldTrigger(triggerZoneId);
      }
      return;
    }

    this.destroyStoryWorldTriggerSensor();
    this.storyWorldTriggerFiredKey = "";
    if (!desiredKey || !triggerZone) return;

    this.storyWorldTriggerSensor = this.matter.add.rectangle(
      triggerZone.x,
      triggerZone.y,
      triggerZone.width,
      triggerZone.height,
      {
        isStatic: true,
        isSensor: true,
        label: `storyWorldTrigger:${triggerZoneId}`,
      },
    );
    this.storyWorldTriggerBounds = new Phaser.Geom.Rectangle(
      triggerZone.x - triggerZone.width / 2,
      triggerZone.y - triggerZone.height / 2,
      triggerZone.width,
      triggerZone.height,
    );
    this.storyWorldTriggerKey = desiredKey;

    if (
      this.player &&
      Phaser.Geom.Rectangle.Contains(
        this.storyWorldTriggerBounds,
        this.player.x,
        this.player.y,
      )
    ) {
      this.fireStoryWorldTrigger(triggerZoneId);
    }
  }

  preload() {
    preloadAvatars(this, SPRITES_MAP);

    if (this.heroUrl) {
      if (this.textures.exists("hero")) {
        this.textures.remove("hero");
      }
      this.load.spritesheet("hero", this.heroUrl, {
        frameWidth: this.heroSpriteConfig.frameWidth,
        frameHeight: this.heroSpriteConfig.frameHeight,
      });
    }
    preloadLocalOrbAvatar(this, this.localOrbAvatarData, this.localOrbTextureKey);

    this.load.spritesheet("vc2CityVoid", cityBVoidPng, {
      frameWidth: TILE_SIZE,
      frameHeight: TILE_SIZE,
    });
    this.load.spritesheet("vc2CityProps", cityCVoidPng, {
      frameWidth: TILE_SIZE,
      frameHeight: TILE_SIZE,
    });
    this.load.spritesheet("vc2CityShell", cityDVoidPng, {
      frameWidth: TILE_SIZE,
      frameHeight: TILE_SIZE,
    });
    this.load.spritesheet("vc2CityFacade", cityEVoidPng, {
      frameWidth: TILE_SIZE,
      frameHeight: TILE_SIZE,
    });
    this.load.spritesheet("vc2ForestGrass", whisperingGrassPng, {
      frameWidth: TILE_SIZE,
      frameHeight: TILE_SIZE,
    });
    this.load.image("vc2TreeAtlas", whisperingPlantPng);
    this.load.image("vc2Template", cityTemplatePng);
    this.load.image("vc2CustomBuildings", customVoidBuildingsPng);
    this.load.spritesheet("vc2CustomBuildingsSheet", customVoidBuildingsPng, {
      frameWidth: TILE_SIZE,
      frameHeight: TILE_SIZE,
    });
    this.load.spritesheet("vc2NpcCourier", cityNpc1Png, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcCourierIdle", cityNpc1IdlePng, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcResident", cityNpc2Png, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcResidentIdle", cityNpc2IdlePng, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcVisitor", cityNpc3Png, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcVisitorIdle", cityNpc3IdlePng, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcVendor", cityNpc4Png, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcVendorIdle", cityNpc4IdlePng, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcWalker", cityNpc5Png, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    this.load.spritesheet("vc2NpcWalkerIdle", cityNpc5IdlePng, {
      frameWidth: NPC_FRAME_SIZE,
      frameHeight: NPC_FRAME_SIZE,
    });
    STORY_CREATURE_CARDS.forEach((creature) => {
      const textureKey = getStoryCreatureTextureKey(creature.id);
      this.load.spritesheet(textureKey, creature.worldImage, {
        frameWidth: 24,
        frameHeight: 24,
      });
    });
    this.load.image("vc2ArenaSign", arenaSignPng);
    this.load.image("vc2MerchantSign", merchantSignPng);
    this.load.image("vc2DecksmithSign", decksmithSignPng);
    this.load.image("vc2QuestMasterSign", questMasterSignPng);
    this.load.spritesheet(STORY_GLYDE_KEY, SPRITES_MAP.glyde, {
      frameWidth: getAvatarSpriteConfig("glyde").frameWidth,
      frameHeight: getAvatarSpriteConfig("glyde").frameHeight,
    });

    AudioManager.loadSFX("door", DOOR_SFX);
  }

  create() {
    applyWorldSceneBackground(this);
    this.mapSource = voidCity2Source;
    this.buildTilesetRegistry();
    this.ensureTreeTextures();
    this.ensureAmbientParticleTextures();
    this.treeSprites = [];
    this.patrolNpcs = [];
    this.currentNpc = null;
    this.remotePlayers = {};
    this.latestPlayers = null;
    this.playersFromReact = null;
    this.selfId = this.userData?.id || null;
    this.pendingOrbTextures = {};
    this.drawMapFromSource();
    this.drawCityProps();
    this.drawCityTrees();
    this.createAmbientParticles();
    this.ensureCityNpcAnimations();
    this.createCityPatrolNpcs();
    this.startTreeWindSway();
    this.createCollisionBodiesFromSource();

    this.matter.world.setBounds(0, 0, MAP_WIDTH, MAP_HEIGHT);
    this.cameras.main.setBounds(0, 0, MAP_WIDTH, MAP_HEIGHT);

    if (this.localOrbAvatarData?.isOrbAvatar) {
      const orbBody = Phaser.Physics.Matter.Matter.Bodies.circle(
        this.spawnPoint.x,
        this.spawnPoint.y,
        ORB_COLLISION_RADIUS,
      );
      this.player = this.matter.add.sprite(
        this.spawnPoint.x,
        this.spawnPoint.y,
        "hero",
        0,
      );
      this.player.setExistingBody(orbBody);
      Phaser.Physics.Matter.Matter.Body.scale(
        this.player.body,
        1,
        ORB_COLLISION_Y_SCALE,
      );
    } else {
      this.player = this.matter.add
        .sprite(this.spawnPoint.x, this.spawnPoint.y, "hero", 0)
        .setBody(scaleAvatarBodySize(this.heroAvatarKey, HUMAN_COLLISION_SIZE));
    }
    this.player
      .setScale(this.heroSpriteConfig.worldScale || 1)
      .setFixedRotation()
      .setDepth(this.spawnPoint.y + 24);
    if (this.heroSpriteConfig.trimBottom) {
      this.player.setCrop(
        0,
        0,
        this.heroSpriteConfig.frameWidth,
        this.heroSpriteConfig.frameHeight - this.heroSpriteConfig.trimBottom,
      );
    }
    this.playerOrbImage = createLocalOrbAvatarImage(
      this,
      this.player,
      this.spawnPoint,
      this.localOrbAvatarData,
      this.localOrbTextureKey,
      { depth: this.spawnPoint.y + 24 },
    );
    this.playerDebugGfx = null;
    this.storyCompanionFollower = createStoryCompanionFollower(this, this.player);
    this.lastFacingDirection = 0;
    this.storyWorldTriggerSensor = null;
    this.storyWorldTriggerBounds = null;
    this.storyWorldTriggerKey = "";
    this.storyWorldTriggerFiredKey = "";
    this.storyGlyde = null;
    this.storyGlydeWalking = false;
    this.storyGlydeHasEntered = false;
    this.storyGlydeCueKey = "";
    this.whisperingForestPortalSensor = null;
    this.whisperingForestPortalVisual = null;
    this.whisperingForestPortalTween = null;
    this.whisperingForestPortalBounds = null;
    this.whisperingForestPortalVisible = false;
    this.storyMissionRuntime = null;
    this.storyRuntimeKey = "";
    this.storyEncounterSprites = new Map();
    this.storyEncounterLaunchId = "";

    this._onStoryWorldEncounterRelease = (event) => {
      const encounterId = String(event?.detail?.encounterId || "");
      if (
        encounterId &&
        this.storyEncounterLaunchId &&
        encounterId !== this.storyEncounterLaunchId
      ) {
        return;
      }
      const entry = this.storyEncounterSprites.get(this.storyEncounterLaunchId);
      if (!entry) {
        this.storyEncounterLaunchId = "";
        return;
      }
      entry.state = "disengaging";
      entry.targetX = entry.homeX;
      entry.targetY = entry.homeY;
    };
    window.addEventListener(
      STORY_WORLD_ENCOUNTER_RELEASE_EVENT,
      this._onStoryWorldEncounterRelease,
    );

    if (this.userData?.id) {
      const currentPresence = this.latestPlayers?.players?.[this.userData.id] || {};
      updatePlayerPresence(this.userData, {
        ...currentPresence,
        partyId: this.userData?.partyId,
        host: this.userData?.isHost,
        inGameRoom: false,
        world: "Void City",
        building: "",
        x: this.player.x,
        y: this.player.y,
        direction: 0,
        animState: "idle",
        device: currentPresence?.device ?? "desktop",
        roomId: currentPresence?.roomId ?? "",
        emote: currentPresence?.emote ?? "",
        level: this.userData?.level,
        name: this.userData?.username,
        avatar: this.userData?.avatar || null,
        orbAvatar: this.userData?.orbAvatar || null,
        online: true,
      });
    }

    this.ensureOrbTexture = (playerData) => {
      const avatarData = resolveAvatarData(playerData);
      if (!avatarData.isOrbAvatar || !avatarData.usesStaticImageOverlay || !avatarData.image) {
        return Promise.resolve("");
      }

      const textureKey = createOrbTextureKey(
        playerData?.orbAvatar || { tokenId: playerData?.id || avatarData.normalizedName },
      );
      if (this.textures.exists(textureKey)) {
        return Promise.resolve(textureKey);
      }
      if (this.pendingOrbTextures[textureKey]) {
        return this.pendingOrbTextures[textureKey];
      }

      this.pendingOrbTextures[textureKey] = new Promise((resolve, reject) => {
        const cleanup = () => {
          this.load.off(`filecomplete-image-${textureKey}`, handleComplete);
          this.load.off("loaderror", handleError);
        };
        const handleComplete = () => {
          cleanup();
          delete this.pendingOrbTextures[textureKey];
          if (this.latestPlayers) {
            this.playersFromReact = this.latestPlayers;
          }
          resolve(textureKey);
        };
        const handleError = (file) => {
          if (file?.key !== textureKey) return;
          cleanup();
          delete this.pendingOrbTextures[textureKey];
          reject(new Error(`Failed to load orb texture: ${textureKey}`));
        };

        this.load.once(`filecomplete-image-${textureKey}`, handleComplete);
        this.load.on("loaderror", handleError);
        this.load.image(textureKey, avatarData.image);
        this.load.start();
      });

      return this.pendingOrbTextures[textureKey];
    };

    this.lastBroadcast = {
      x: null,
      y: null,
      direction: null,
      animState: null,
    };

    this.events.on("setPlayers", (players, selfId) => {
      this.latestPlayers = { players, selfId };
      this.playersFromReact = { players, selfId };
      this.selfId = selfId;
    });

    const isMobile =
      this.sys.game.device.os.android || this.sys.game.device.os.iOS;
    this.cameras.main
      .startFollow(this.player, true, 0.1, 0.1)
      .setZoom(isMobile ? 1.1 : 1.65);

    createWalkAnimations(this, "hero", this.heroAvatarKey);
    createWalkAnimations(
      this,
      STORY_GLYDE_KEY,
      "glyde",
      STORY_GLYDE_ANIMATION_PREFIX,
    );

    this.currentDoor = null;
    this.simpleDoors = {};
    this.createExitPortalVisual();
    this.syncWhisperingForestPortalVisual();
    this.createDoorSpritesFromSource();
    this.syncStoryWorldTriggerSensor();

    const getStoryGlydeTargetPosition = () => {
      const zone = STORY_GLYDE_TRIGGER_GROVE_BOUNDS;

      return {
        x: Phaser.Math.Clamp(
          (this.player?.x ?? zone.left) + STORY_GLYDE_APPROACH_OFFSET.x,
          zone.left + 72,
          zone.left + zone.width - 72,
        ),
        y: Phaser.Math.Clamp(
          (this.player?.y ?? zone.top) + STORY_GLYDE_APPROACH_OFFSET.y,
          zone.top + 88,
          zone.top + zone.height - 88,
        ),
      };
    };

    const syncStoryGlydeDepth = () => {
      if (!this.storyGlyde) return;
      this.storyGlyde.setDepth(this.storyGlyde.y + 28);
    };

    const clearStoryGlyde = () => {
      this.storyGlyde?.destroy?.();
      this.storyGlyde = null;
      this.storyGlydeWalking = false;
      this.storyGlydeHasEntered = false;
    };

    const buildStoryGlyde = (position = STORY_GLYDE_ENTRY_POSITION) => {
      if (this.storyGlyde) return this.storyGlyde;

      const spriteConfig = getAvatarSpriteConfig("glyde");
      this.storyGlyde = this.add
        .sprite(position.x, position.y, STORY_GLYDE_KEY, 0)
        .setOrigin(0.5, 1)
        .setScale(spriteConfig.worldScale || 1);
      this.storyGlyde.setFrame(
        getAvatarFrameForDirection("glyde", STORY_GLYDE_IDLE_DIRECTION, 0),
      );
      syncStoryGlydeDepth();
      return this.storyGlyde;
    };

    const setStoryGlydeIdle = () => {
      if (!this.storyGlyde) return;
      this.storyGlyde.anims?.stop?.();
      this.storyGlyde.setFrame(
        getAvatarFrameForDirection("glyde", STORY_GLYDE_IDLE_DIRECTION, 0),
      );
    };

    const notifyStorySceneCueComplete = (missionId, cueId, lineIndex) => {
      if (typeof window === "undefined" || !missionId || !cueId) return;

      window.dispatchEvent(
        new CustomEvent("story-scene-cue-complete", {
          detail: {
            missionId,
            cueId,
            lineIndex,
            sceneKey: this.scene.key,
          },
        }),
      );

      if (missionId === STORY_GLYDE_MISSION_ID && cueId === "glyde-enter") {
        window.dispatchEvent(
          new CustomEvent("story-world-dialog-request", {
            detail: {
              missionId,
              sceneKey: this.scene.key,
              triggerZoneId: STORY_GLYDE_TRIGGER_ID,
            },
          }),
        );
      }
    };

    const handleStorySceneCue = (event) => {
      const missionId = String(event?.detail?.missionId || "");
      const cueId = String(event?.detail?.cue?.id || "");
      const lineIndex = Number(event?.detail?.lineIndex ?? -1);

      if (
        this.userData?.activeGameMode !== "story" ||
        missionId !== "act-1-mission-11" ||
        !cueId
      ) {
        return;
      }

      const cueKey = `${missionId}:${cueId}:${event?.detail?.lineIndex ?? 0}`;
      if (this.storyGlydeCueKey === cueKey) return;
      this.storyGlydeCueKey = cueKey;

      if (cueId === "glyde-enter") {
        if (this.storyGlydeWalking) return;
        if (this.storyGlydeHasEntered) {
          notifyStorySceneCueComplete(missionId, cueId, lineIndex);
          return;
        }

        const targetPosition = getStoryGlydeTargetPosition();
        const glyde = buildStoryGlyde(STORY_GLYDE_ENTRY_POSITION);
        glyde.setPosition(STORY_GLYDE_ENTRY_POSITION.x, STORY_GLYDE_ENTRY_POSITION.y);
        glyde.play(`${STORY_GLYDE_ANIMATION_PREFIX}-left`, true);
        syncStoryGlydeDepth();
        this.storyGlydeWalking = true;
        this.tweens.killTweensOf(glyde);

        this.tweens.add({
          targets: glyde,
          x: targetPosition.x,
          y: targetPosition.y,
          duration: 1850,
          ease: "Sine.easeOut",
          onUpdate: () => {
            syncStoryGlydeDepth();
          },
          onComplete: () => {
            this.storyGlydeWalking = false;
            this.storyGlydeHasEntered = true;
            setStoryGlydeIdle();
            syncStoryGlydeDepth();
            console.log("[StoryWorld] Glyde enter cue complete", {
              missionId,
              cueId,
              lineIndex,
            });
            notifyStorySceneCueComplete(missionId, cueId, lineIndex);
          },
        });
        return;
      }

      if (cueId === "glyde-exit") {
        const glyde = buildStoryGlyde(getStoryGlydeTargetPosition());
        this.storyGlydeWalking = true;
        glyde.play(`${STORY_GLYDE_ANIMATION_PREFIX}-left`, true);
        this.tweens.killTweensOf(glyde);
        this.tweens.add({
          targets: glyde,
          x: STORY_GLYDE_EXIT_POSITION.x,
          y: STORY_GLYDE_EXIT_POSITION.y,
          duration: 1650,
          ease: "Sine.easeInOut",
          onUpdate: () => {
            syncStoryGlydeDepth();
          },
          onComplete: () => {
            clearStoryGlyde();
            notifyStorySceneCueComplete(missionId, cueId, lineIndex);
          },
        });
      }
    };

    window.addEventListener("story-scene-cue", handleStorySceneCue);

    this.matter.world.on("collisionstart", (event) => {
      event.pairs.forEach(({ bodyA, bodyB }) => {
        const sensor = bodyA.isSensor ? bodyA : bodyB.isSensor ? bodyB : null;
        const isPlayer =
          bodyA === this.player.body || bodyB === this.player.body;

        if (sensor && isPlayer) {
          if (sensor.label === "exit") {
            this.currentDoor = "exit";
            window.dispatchEvent(
              new CustomEvent("interact-proximity", { detail: true }),
            );
            window.dispatchEvent(
              new CustomEvent("door-name", { detail: "Return To Void City" }),
            );
          } else if (sensor.label === WHISPERING_FOREST_PORTAL_LABEL) {
            this.currentDoor = WHISPERING_FOREST_PORTAL_LABEL;
            window.dispatchEvent(
              new CustomEvent("interact-proximity", { detail: true }),
            );
            window.dispatchEvent(
              new CustomEvent("door-name", { detail: "Enter Whispering Forest" }),
            );
          } else if (sensor.label?.startsWith("simpleDoor:")) {
            this.currentDoor = sensor.label;
            window.dispatchEvent(
              new CustomEvent("interact-proximity", { detail: true }),
            );
            window.dispatchEvent(
              new CustomEvent("door-name", {
                detail:
                  sensor.label === `simpleDoor:${ARENA_DOOR_ID}`
                    ? "Enter Arena"
                    : sensor.label === `simpleDoor:${MERCHANT_DOOR_ID}`
                      ? "Enter Merchant"
                      : sensor.label === `simpleDoor:${DECKSMITH_DOOR_ID}`
                        ? "Enter Decksmith"
                        : sensor.label === `simpleDoor:${GAME_HALL_DOOR_ID}`
                          ? "Enter Game Hall"
                        : sensor.label === `simpleDoor:${QUESTMASTER_DOOR_ID}`
                          ? "Enter Quest Hall"
                          : "Open Door",
              }),
            );
          } else if (sensor.label?.startsWith("storyWorldTrigger:")) {
            this.fireStoryWorldTrigger(
              sensor.label.replace("storyWorldTrigger:", ""),
            );
          }
        }
      });
    });

    this.matter.world.on("collisionend", (event) => {
      event.pairs.forEach(({ bodyA, bodyB }) => {
        const sensor = bodyA.isSensor ? bodyA : bodyB.isSensor ? bodyB : null;
        const isPlayer =
          bodyA === this.player.body || bodyB === this.player.body;

        if (sensor && isPlayer) {
          if (sensor.label === this.currentDoor) {
            this.currentDoor = null;
            if (this.currentNpc) {
              this.setNpcInteractionTarget(this.currentNpc);
            } else {
              window.dispatchEvent(
                new CustomEvent("interact-proximity", { detail: false }),
              );
              window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
            }
          }
        }
      });
    });

    this.joystick = { x: 0, y: 0 };
    this.cursors = this.input.keyboard.createCursorKeys();
    this.keys = this.input.keyboard.addKeys({
      W: Phaser.Input.Keyboard.KeyCodes.W,
      A: Phaser.Input.Keyboard.KeyCodes.A,
      S: Phaser.Input.Keyboard.KeyCodes.S,
      D: Phaser.Input.Keyboard.KeyCodes.D,
    });

    this.spaceKey = this.input.keyboard.addKey(
      Phaser.Input.Keyboard.KeyCodes.SPACE,
    );
    this._onEnter = () => {
      if (
        typeof window !== "undefined" &&
        (
          window.__storySceneInputLocked ||
          window.__storyWorldEncounterPaused
        )
      ) {
        return;
      }

      if (this.currentNpc && !this.currentDoor) {
        const dialogueScript = buildNpcDialogueScript(this.currentNpc);
        if (dialogueScript.length > 0) {
          window.dispatchEvent(
            new CustomEvent("npc-dialogue", { detail: dialogueScript }),
          );
        }
        return;
      }

      if (!this.currentDoor) return;

      if (this.currentDoor === WHISPERING_FOREST_PORTAL_LABEL) {
        this.enterWhisperingForestScene();
        return;
      }

      if (this.currentDoor.startsWith("simpleDoor:")) {
        const doorId = this.currentDoor.replace("simpleDoor:", "");
        if (doorId === ARENA_DOOR_ID) {
          const arenaDoor = this.simpleDoors[doorId];
          if (arenaDoor?.isOpen) {
            this.enterArenaScene();
            return;
          }
          this.openSimpleDoor(doorId, () => this.enterArenaScene());
          return;
        }
        if (doorId === MERCHANT_DOOR_ID) {
          const merchantDoor = this.simpleDoors[doorId];
          if (merchantDoor?.isOpen) {
            this.enterMerchantScene();
            return;
          }
          this.openSimpleDoor(doorId, () => this.enterMerchantScene());
          return;
        }
        if (doorId === DECKSMITH_DOOR_ID) {
          const decksmithDoor = this.simpleDoors[doorId];
          if (decksmithDoor?.isOpen) {
            this.enterDecksmithScene();
            return;
          }
          this.openSimpleDoor(doorId, () => this.enterDecksmithScene());
          return;
        }
        if (doorId === GAME_HALL_DOOR_ID) {
          const gameHallDoor = this.simpleDoors[doorId];
          if (gameHallDoor?.isOpen) {
            this.enterGameHallScene();
            return;
          }
          this.openSimpleDoor(doorId, () => this.enterGameHallScene());
          return;
        }
        if (doorId === QUESTMASTER_DOOR_ID) {
          const questDoor = this.simpleDoors[doorId];
          if (questDoor?.isOpen) {
            this.enterQuestHallScene();
            return;
          }
          this.openSimpleDoor(doorId, () => this.enterQuestHallScene());
          return;
        }
        this.openSimpleDoor(doorId);
        return;
      }

      if (this.currentDoor !== "exit") return;

      AudioManager.playSFX("door");
      this.cameras.main.fadeOut(300, 0, 0, 0);
      this.cameras.main.once("camerafadeoutcomplete", () => {
        this.scene.stop(this.scene.key);
        this.scene.start("VoidCity2Scene", {
          spawn: this.returnSpawn,
          returnSpawn: this.returnSpawn,
          heroUrl: this.heroUrl,
          heroAvatarKey: this.heroAvatarKey,
          userData: this.userData,
        });
      });
    };

    this.spaceKey.on("down", this._onEnter);
    window.addEventListener("press-enter", this._onEnter);

    this.events.once("shutdown", () => {
      this.spaceKey?.off?.("down", this._onEnter);
      window.removeEventListener("press-enter", this._onEnter);
      window.removeEventListener("story-scene-cue", handleStorySceneCue);
      window.removeEventListener(
        STORY_WORLD_ENCOUNTER_RELEASE_EVENT,
        this._onStoryWorldEncounterRelease,
      );
      Object.values(this.remotePlayers || {}).forEach((entry) => {
        destroyRemotePlayerVisual(entry);
      });
      this.remotePlayers = {};
      destroyStoryCompanionFollower(this.storyCompanionFollower);
      this.destroyStoryEncounterSprites();
      this.destroyWhisperingForestPortalVisual();
      this.destroyStoryWorldTriggerSensor();
      clearStoryGlyde();
      window.dispatchEvent(new CustomEvent("npc-proximity", { detail: null }));
      window.dispatchEvent(
        new CustomEvent("interact-proximity", { detail: false }),
      );
      window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    });

    this.cameras.main.fadeIn(300, 0, 0, 0);
  }

  enterArenaScene() {
    this.currentDoor = null;
    window.dispatchEvent(
      new CustomEvent("interact-proximity", { detail: false }),
    );
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("ArenaScene", {
        spawn: { x: 300, y: 300 },
        exit: this.getDoorReturnSpawn(ARENA_DOOR_ID),
        building: "arena",
        heroUrl: this.heroUrl,
        heroAvatarKey: this.heroAvatarKey,
        userData: this.userData,
      });
    });
  }

  enterMerchantScene() {
    this.currentDoor = null;
    window.dispatchEvent(
      new CustomEvent("interact-proximity", { detail: false }),
    );
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("MerchantScene", {
        spawn: { x: 300, y: 300 },
        exit: this.getDoorReturnSpawn(MERCHANT_DOOR_ID),
        building: "merchant",
        heroUrl: this.heroUrl,
        heroAvatarKey: this.heroAvatarKey,
        userData: this.userData,
      });
    });
  }

  enterDecksmithScene() {
    this.currentDoor = null;
    window.dispatchEvent(
      new CustomEvent("interact-proximity", { detail: false }),
    );
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("DecksmithScene", {
        spawn: { x: 300, y: 300 },
        exit: this.getDoorReturnSpawn(DECKSMITH_DOOR_ID),
        building: "decksmith",
        heroUrl: this.heroUrl,
        heroAvatarKey: this.heroAvatarKey,
        userData: this.userData,
      });
    });
  }

  enterGameHallScene() {
    this.currentDoor = null;
    window.dispatchEvent(
      new CustomEvent("interact-proximity", { detail: false }),
    );
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("GameHallScene", {
        spawn: { x: 300, y: 300 },
        exit: this.getDoorReturnSpawn(GAME_HALL_DOOR_ID),
        building: "gameHall",
        heroUrl: this.heroUrl,
        heroAvatarKey: this.heroAvatarKey,
        userData: this.userData,
      });
    });
  }

  enterQuestHallScene() {
    this.currentDoor = null;
    window.dispatchEvent(
      new CustomEvent("interact-proximity", { detail: false }),
    );
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("QuestHallScene", {
        spawn: { x: 300, y: 300 },
        exit: this.getDoorReturnSpawn(QUESTMASTER_DOOR_ID),
        building: "questHall",
        heroUrl: this.heroUrl,
        heroAvatarKey: this.heroAvatarKey,
        userData: this.userData,
      });
    });
  }

  canEnterWhisperingForest() {
    if (this.userData?.activeGameMode !== "story") return true;
    return this.isWhisperingForestUnlocked();
  }

  getStoryProgressSnapshot() {
    const storyStore = useStoryStore.getState();
    const launchTarget =
      (typeof window !== "undefined" ? window.__storyLaunchTarget || null : null) ||
      storyStore?.currentLaunchTarget ||
      storyStore?.progress?.currentLaunchTarget ||
      null;

    return {
      launchTarget,
      currentMissionId:
        storyStore?.currentMissionId ||
        storyStore?.progress?.currentMissionId ||
        launchTarget?.missionId ||
        "",
      currentMissionNumber: Number(
        launchTarget?.missionNumber ||
          storyStore?.progress?.currentMission ||
          0,
      ),
      currentActNumber: Number(
        launchTarget?.actNumber ||
          storyStore?.progress?.currentAct ||
          0,
      ),
    };
  }

  isWhisperingForestUnlocked() {
    if (this.userData?.activeGameMode !== "story") {
      return ENABLE_VOID_CITY_2_EXITS;
    }

    const {
      currentMissionId,
      currentMissionNumber,
      currentActNumber,
    } = this.getStoryProgressSnapshot();

    if (
      currentMissionId === "act-1-mission-12" ||
      currentMissionId === "act-1-mission-13" ||
      currentMissionId === "act-1-mission-14"
    ) {
      return true;
    }

    return currentActNumber > 1 || currentMissionNumber >= 12;
  }

  getDoorReturnSpawn(doorId) {
    const explicitSpawn = getVoidCityExteriorReturnSpawnByDoorId(doorId);
    if (explicitSpawn) {
      return explicitSpawn;
    }

    const door = this.simpleDoors?.[doorId];
    if (door?.sprite) {
      return {
        x: door.sprite.x + TILE_SIZE / 2,
        y: door.sprite.y + TILE_SIZE + BUILDING_EXIT_SPAWN_Y_OFFSET,
      };
    }

    const [, tileXText, tileYText] = doorId.match(/^door-(\d+)-(\d+)$/) || [];
    if (tileXText && tileYText) {
      const tileX = Number(tileXText);
      const tileY = Number(tileYText);
      return {
        x: tileX * TILE_SIZE + TILE_SIZE / 2,
        y: tileY * TILE_SIZE + TILE_SIZE + BUILDING_EXIT_SPAWN_Y_OFFSET,
      };
    }

    return { x: 448, y: 1088 };
  }

  enterWhisperingForestScene() {
    this.currentDoor = null;
    window.dispatchEvent(
      new CustomEvent("interact-proximity", { detail: false }),
    );
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
    if (!this.canEnterWhisperingForest()) {
      window.dispatchEvent(
        new CustomEvent("npc-dialogue", {
          detail: buildWhisperingForestLockedScript(),
        }),
      );
      return;
    }
    AudioManager.playSFX("door");
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () => {
      this.scene.start("WhisperingForestScene", {
        returnSpawn: WHISPERING_FOREST_PORTAL_RETURN_SPAWN,
        heroUrl: this.heroUrl,
        heroAvatarKey: this.heroAvatarKey,
        userData: this.userData,
        ...(this.userData?.activeGameMode === "story"
          ? { forestChestMode: WHISPERING_FOREST_STORY_PACK_CHEST_MODE }
          : {}),
      });
    });
  }

  syncStoryEncounterRuntime() {
    const runtime = readStoryMissionEncounterRuntime();
    const nextRuntimeKey = JSON.stringify({
      missionId: runtime?.missionId || "",
      sceneKey: runtime?.sceneKey || "",
      encounterSetId: runtime?.encounterSetId || "",
      defeatedEncounterIds: runtime?.defeatedEncounterIds || [],
      encounterIds: (runtime?.encounters || []).map((encounter) => encounter?.encounterId),
    });

    if (this.storyRuntimeKey === nextRuntimeKey) {
      return runtime;
    }

    this.storyRuntimeKey = nextRuntimeKey;
    this.storyMissionRuntime = runtime;

    if (
      runtime?.encounterMode === "roamingCreatureClear" &&
      String(runtime?.sceneKey || "") === this.scene.key
    ) {
      this.ensureStoryEncounterSprites(runtime);
      this.syncStoryEncounterVisibility(runtime);
      return runtime;
    }

    this.destroyStoryEncounterSprites();
    return runtime;
  }

  ensureStoryEncounterSprites(runtime = null) {
    const encounters = Array.isArray(runtime?.encounters) ? runtime.encounters : [];
    const nextEncounterIds = new Set(
      encounters.map((encounter) => String(encounter?.encounterId || "")),
    );

    this.storyEncounterSprites.forEach((entry, encounterId) => {
      if (nextEncounterIds.has(String(encounterId || ""))) return;
      entry?.sprite?.destroy?.();
      entry?.shadow?.destroy?.();
      entry?.badgeBg?.destroy?.();
      entry?.badgeText?.destroy?.();
      this.storyEncounterSprites.delete(encounterId);
    });

    encounters.forEach((encounter) => {
      const creature = getStoryCreatureCard(encounter.leadCreatureId);
      const textureKey = getStoryCreatureTextureKey(
        creature?.id || encounter.encounterId,
      );
      if (!creature || !this.textures.exists(textureKey)) return;
      if (this.storyEncounterSprites.has(encounter.encounterId)) return;

      this.ensureStoryCreatureAnimations(creature.id);
      const sprite = this.add
        .sprite(encounter.home.x, encounter.home.y, textureKey, 0)
        .setScale(STORY_ENCOUNTER_SCALE)
        .setDepth(encounter.home.y + 8);
      const shadow = this.add.ellipse(
        encounter.home.x,
        encounter.home.y + 14,
        34,
        12,
        0x102215,
        STORY_ENCOUNTER_SHADOW_ALPHA,
      ).setDepth(encounter.home.y + 7);
      const badgeBg = this.add.graphics().setDepth(encounter.home.y + 18);
      const badgeText = this.add.text(0, 0, `x${encounter.creatureIds.length}`, {
        font: "bold 14px Arial",
        fill: "#f7fff1",
        stroke: "#0e2012",
        strokeThickness: 4,
      })
        .setOrigin(0.5)
        .setDepth(encounter.home.y + 19);

      this.storyEncounterSprites.set(encounter.encounterId, {
        encounterId: encounter.encounterId,
        encounter,
        creature,
        sprite,
        shadow,
        badgeBg,
        badgeText,
        homeX: encounter.home.x,
        homeY: encounter.home.y,
        x: encounter.home.x,
        y: encounter.home.y,
        targetX: encounter.home.x,
        targetY: encounter.home.y,
        state: "idle",
        waitUntil: 0,
        hidden: false,
        lastDirection: "down",
      });
    });
  }

  ensureStoryCreatureAnimations(creatureId = "") {
    const normalizedCreatureId = String(creatureId || "").trim().toLowerCase();
    if (!normalizedCreatureId) return;

    const textureKey = getStoryCreatureTextureKey(normalizedCreatureId);
    if (!this.textures.exists(textureKey)) return;

    Object.entries(STORY_CREATURE_ANIMATION_ROWS).forEach(([direction, rowIndex]) => {
      const animationKey = getStoryCreatureAnimationKey(
        normalizedCreatureId,
        direction,
      );
      if (this.anims.exists(animationKey)) return;

      const start = rowIndex * STORY_CREATURE_FRAMES_PER_ROW;
      const end = start + STORY_CREATURE_FRAMES_PER_ROW - 1;
      this.anims.create({
        key: animationKey,
        frames: this.anims.generateFrameNumbers(textureKey, { start, end }),
        frameRate: STORY_CREATURE_ANIMATION_FRAME_RATE,
        repeat: direction === "dead" ? 0 : -1,
      });
    });
  }

  setStoryEncounterAnimation(entry, direction = "down", moving = false) {
    if (!entry?.sprite || !entry?.creature?.id) return;
    const nextDirection = Object.prototype.hasOwnProperty.call(
      STORY_CREATURE_ANIMATION_ROWS,
      direction,
    )
      ? direction
      : "down";
    entry.lastDirection = nextDirection;

    if (moving) {
      const animationKey = getStoryCreatureAnimationKey(
        entry.creature.id,
        nextDirection,
      );
      if (entry.sprite.anims.currentAnim?.key !== animationKey) {
        entry.sprite.play(animationKey, true);
      }
      return;
    }

    entry.sprite.anims.stop();
    entry.sprite.setFrame(
      Number(STORY_CREATURE_ANIMATION_ROWS[nextDirection] || 0) *
        STORY_CREATURE_FRAMES_PER_ROW,
    );
  }

  destroyStoryEncounterSprites() {
    this.storyEncounterLaunchId = "";
    this.storyEncounterSprites.forEach((entry) => {
      entry?.sprite?.destroy?.();
      entry?.shadow?.destroy?.();
      entry?.badgeBg?.destroy?.();
      entry?.badgeText?.destroy?.();
    });
    this.storyEncounterSprites.clear();
  }

  syncStoryEncounterVisibility(runtime = null) {
    const defeatedEncounterIds = new Set(runtime?.defeatedEncounterIds || []);
    this.storyEncounterSprites.forEach((entry) => {
      const hidden = defeatedEncounterIds.has(entry.encounterId);
      entry.hidden = hidden;
      entry.sprite.setVisible(!hidden);
      entry.shadow.setVisible(!hidden);
      entry.badgeText.setVisible(!hidden);
      entry.badgeBg.setVisible(!hidden);

      if (hidden && this.storyEncounterLaunchId === entry.encounterId) {
        this.storyEncounterLaunchId = "";
      }

      if (hidden) {
        entry.sprite.anims?.stop?.();
      } else {
        this.setStoryEncounterAnimation(entry, entry.lastDirection || "down", false);
      }
    });
  }

  createRandomEncounterHomeTarget(entry) {
    const halfWidth = Number(entry?.encounter?.homeBounds?.width || 0) / 2;
    const halfHeight = Number(entry?.encounter?.homeBounds?.height || 0) / 2;

    return {
      x: Phaser.Math.Clamp(entry.homeX + Phaser.Math.Between(-halfWidth, halfWidth), 36, MAP_WIDTH - 36),
      y: Phaser.Math.Clamp(entry.homeY + Phaser.Math.Between(-halfHeight, halfHeight), 36, MAP_HEIGHT - 36),
    };
  }

  updateStoryEncounterSprites() {
    const runtime = this.storyMissionRuntime;
    let encountersPaused =
      typeof window !== "undefined" && Boolean(window.__storyWorldEncounterPaused);
    if (
      encountersPaused ||
      !runtime ||
      runtime?.encounterMode !== "roamingCreatureClear" ||
      String(runtime?.sceneKey || "") !== this.scene.key
    ) {
      return;
    }

    this.storyEncounterSprites.forEach((entry) => {
      if (entry.hidden || encountersPaused) return;

      const { encounter } = entry;
      const dxToPlayer = this.player.x - entry.x;
      const dyToPlayer = this.player.y - entry.y;
      const distanceToPlayer = Math.hypot(dxToPlayer, dyToPlayer);

      if (
        this.storyEncounterLaunchId !== entry.encounterId &&
        distanceToPlayer <= Number(encounter.touchRange || 34)
      ) {
        const encounterDetail = {
          missionId: runtime?.missionId || "",
          encounterMode: runtime?.encounterMode || "",
          questId: runtime?.questId || "",
          encounterSetId: runtime?.encounterSetId || null,
          encounterId: entry.encounterId,
          sceneKey: this.scene.key,
          world: runtime?.world || null,
          playerWorld: {
            ...(runtime?.world || {}),
            mapId: "voidCity",
            building: "",
            x: this.player.x,
            y: this.player.y,
            facingDirection: this.lastFacingDirection,
          },
        };
        this.storyEncounterLaunchId = entry.encounterId;
        if (typeof window !== "undefined") {
          window.__storyWorldEncounterPaused = true;
          window.__pendingStoryWorldEncounter = encounterDetail;
        }
        encountersPaused = true;
        window.dispatchEvent(
          new CustomEvent("story-world-encounter", {
            detail: encounterDetail,
          }),
        );
        return;
      }

      if (
        entry.state !== "chasing" &&
        entry.state !== "disengaging" &&
        distanceToPlayer <= Number(encounter.aggroRange || 128)
      ) {
        entry.state = "chasing";
      } else if (
        entry.state === "chasing" &&
        distanceToPlayer >= Number(encounter.giveUpRange || 240)
      ) {
        entry.state = "returning";
      }

      if (entry.state === "idle" && this.time.now >= entry.waitUntil) {
        const nextTarget = this.createRandomEncounterHomeTarget(entry);
        entry.targetX = nextTarget.x;
        entry.targetY = nextTarget.y;
        entry.state = "roaming";
      }

      let targetX = entry.targetX;
      let targetY = entry.targetY;
      let speed = Number(encounter.roamSpeed || 0.35);

      if (entry.state === "chasing") {
        targetX = this.player.x;
        targetY = this.player.y;
        speed = Number(encounter.chaseSpeed || 1.3);
      } else if (entry.state === "returning" || entry.state === "disengaging") {
        targetX = entry.homeX;
        targetY = entry.homeY;
        speed = Number(encounter.chaseSpeed || 1.3) * 0.82;
      }

      const dx = targetX - entry.x;
      const dy = targetY - entry.y;
      const distance = Math.hypot(dx, dy);
      let isMoving = false;
      let nextDirection = entry.lastDirection || "down";

      if (distance <= Math.max(1, speed + 0.25)) {
        entry.x = targetX;
        entry.y = targetY;
        if (entry.state === "roaming") {
          entry.state = "idle";
          entry.waitUntil = this.time.now + STORY_ENCOUNTER_IDLE_WAIT_MS;
        } else if (entry.state === "returning" || entry.state === "disengaging") {
          if (
            entry.state === "disengaging" &&
            this.storyEncounterLaunchId === entry.encounterId
          ) {
            this.storyEncounterLaunchId = "";
          }
          entry.state = "idle";
          entry.waitUntil = this.time.now + 600;
        }
      } else if (distance > 0) {
        entry.x += (dx / distance) * speed;
        entry.y += (dy / distance) * speed;
        isMoving = true;
        if (Math.abs(dy) > Math.abs(dx)) {
          nextDirection = dy < 0 ? "up" : "down";
        } else {
          nextDirection = dx < 0 ? "left" : "right";
        }
      }

      this.setStoryEncounterAnimation(entry, nextDirection, isMoving);
      entry.sprite.setPosition(entry.x, entry.y).setDepth(entry.y + 10);
      entry.shadow.setPosition(entry.x, entry.y + 14).setDepth(entry.y + 9);
      entry.badgeText
        .setPosition(entry.x, entry.y - STORY_ENCOUNTER_LABEL_OFFSET_Y)
        .setDepth(entry.y + 20);
      entry.badgeBg.clear();
      entry.badgeBg
        .fillStyle(0x102215, 0.74)
        .fillRoundedRect(entry.x - 16, entry.y - 48, 32, 20, 8)
        .lineStyle(2, 0xeaf6db, 0.9)
        .strokeRoundedRect(entry.x - 16, entry.y - 48, 32, 20, 8)
        .setDepth(entry.y + 19);
    });
  }

  buildTilesetRegistry() {
    const textureKeyByBasename = {
      "grass1.tsx": "vc2ForestGrass",
      "city-void-base.tsx": "vc2CityVoid",
      "road.tsx": "vc2CityVoid",
      "decor.tsx": "vc2CityProps",
      "buildings.tsx": "vc2CityShell",
      "city-void-facade.tsx": "vc2CityFacade",
      "voidcitybuildings.tsx": "vc2CustomBuildingsSheet",
    };

    this.tilesetRegistry = [...(this.mapSource?.tilesets || [])]
      .map((tileset) => ({
        ...tileset,
        textureKey: textureKeyByBasename[tileset.basename || tileset.source?.split("/").pop()],
      }))
      .filter((tileset) => tileset.textureKey)
      .sort((a, b) => a.firstgid - b.firstgid);
  }

  resolveTilesetForGid(gid) {
    if (!gid) return null;

    let found = null;
    this.tilesetRegistry.forEach((tileset) => {
      if (tileset.firstgid <= gid) {
        found = tileset;
      }
    });

    if (!found) return null;
    return {
      ...found,
      frame: gid - found.firstgid,
    };
  }

  getLayerByName(name) {
    return this.mapSource?.layers?.find(
      (layer) => layer.type === "tilelayer" && layer.name === name,
    );
  }

  getObjectLayerByName(name) {
    return this.mapSource?.layers?.find(
      (layer) => layer.type === "objectgroup" && layer.name === name,
    );
  }

  getSourceLayerOrder(layer) {
    if (Number.isFinite(layer?.order)) {
      return layer.order;
    }

    return this.mapSource?.layers?.indexOf(layer) ?? Number.MAX_SAFE_INTEGER;
  }

  getOrderedRenderableSourceLayers() {
    return (this.mapSource?.layers || [])
      .filter(
        (layer) =>
          layer.type === "tilelayer"
          && RENDERABLE_SOURCE_LAYER_NAMES.includes(layer.name),
      )
      .sort((a, b) => this.getSourceLayerOrder(a) - this.getSourceLayerOrder(b));
  }

  drawStaticLayerFromSource(layerName, depth) {
    const layer = this.getLayerByName(layerName);
    if (!layer) return;

    const rt = this.make.renderTexture({
      width: MAP_WIDTH,
      height: MAP_HEIGHT,
      add: false,
    });

    layer.data.forEach((gid, index) => {
      if (!gid) return;
      const resolved = this.resolveTilesetForGid(gid);
      if (!resolved) return;

      const tx = index % layer.width;
      const ty = Math.floor(index / layer.width);
      rt.drawFrame(
        resolved.textureKey,
        resolved.frame,
        tx * TILE_SIZE,
        ty * TILE_SIZE,
      );
    });

    const textureKey = `vc2-${layerName}`;
    if (this.textures.exists(textureKey)) {
      this.textures.remove(textureKey);
    }
    rt.saveTexture(textureKey);
    this.add.image(0, 0, textureKey).setOrigin(0).setDepth(depth);
  }

  drawMapFromSource() {
    this.getOrderedRenderableSourceLayers().forEach((layer, index) => {
      const depth = index + 1;
      if (layer.name === "Signs") {
        this.drawSignsFromSource(depth);
        return;
      }

      this.drawStaticLayerFromSource(layer.name, depth);
    });

    this.add
      .text(56, 48, "Void City 2", {
        font: "28px Arial",
        fill: "#eef2ff",
        stroke: "#1c1f48",
        strokeThickness: 6,
      })
      .setOrigin(0, 0.5)
      .setDepth(3001)
      .setScrollFactor(0.15);
  }

  drawSignsFromSource(depth = 1) {
    const layer = this.getLayerByName("Signs");
    if (!layer) return;
    const seen = new Set();

    for (let ty = 0; ty < layer.height; ty += 1) {
      for (let tx = 0; tx < layer.width; tx += 1) {
        const index = ty * layer.width + tx;
        if (!layer.data[index] || seen.has(index)) continue;

        const queue = [[tx, ty]];
        const cells = [];
        seen.add(index);

        while (queue.length > 0) {
          const [cx, cy] = queue.pop();
          cells.push({ x: cx, y: cy });
          [
            [1, 0],
            [-1, 0],
            [0, 1],
            [0, -1],
          ].forEach(([dx, dy]) => {
            const nx = cx + dx;
            const ny = cy + dy;
            if (nx < 0 || ny < 0 || nx >= layer.width || ny >= layer.height) {
              return;
            }
            const neighborIndex = ny * layer.width + nx;
            if (!layer.data[neighborIndex] || seen.has(neighborIndex)) return;
            seen.add(neighborIndex);
            queue.push([nx, ny]);
          });
        }

        const xs = cells.map((cell) => cell.x);
        const ys = cells.map((cell) => cell.y);
        const minX = Math.min(...xs);
        const minY = Math.min(...ys);
        const widthTiles = Math.max(...xs) - minX + 1;
        const heightTiles = Math.max(...ys) - minY + 1;
        let textureKey = "vc2ArenaSign";
        if (widthTiles >= 3 || heightTiles >= 3) {
          if (minX === 4 && minY === 30) {
            textureKey = "vc2MerchantSign";
          } else if (minX === 19 && minY === 29) {
            textureKey = "vc2DecksmithSign";
          } else if (minX === 17 && minY === 47) {
            textureKey = "vc2QuestMasterSign";
          }
        }

        this.add
          .image(minX * TILE_SIZE, minY * TILE_SIZE, textureKey)
          .setOrigin(0, 0)
          .setDepth(depth);
      }
    }
  }

  ensureTreeTextures() {
    const source = this.textures.get("vc2TreeAtlas")?.getSourceImage();
    if (!source) return;

    Object.entries(TREE_TEXTURE_RECTS).forEach(([kind, rect]) => {
      const baseHeight = TREE_LOCKED_BASE_HEIGHT[kind] || 20;
      const canopyHeight = rect.height - baseHeight;
      const canopyKey = `vc2-tree-${kind}-canopy`;
      const baseKey = `vc2-tree-${kind}-base`;

      if (!this.textures.exists(canopyKey)) {
        const canopyTexture = this.textures.createCanvas(
          canopyKey,
          rect.width,
          canopyHeight,
        );
        const canopyCtx = canopyTexture.context;
        canopyCtx.drawImage(
          source,
          rect.x,
          rect.y,
          rect.width,
          canopyHeight,
          0,
          0,
          rect.width,
          canopyHeight,
        );
        canopyTexture.refresh();
      }

      if (!this.textures.exists(baseKey)) {
        const baseTexture = this.textures.createCanvas(
          baseKey,
          rect.width,
          baseHeight,
        );
        const baseCtx = baseTexture.context;
        baseCtx.drawImage(
          source,
          rect.x,
          rect.y + canopyHeight,
          rect.width,
          baseHeight,
          0,
          0,
          rect.width,
          baseHeight,
        );
        baseTexture.refresh();
      }
    });
  }

  ensureAmbientParticleTextures() {
    if (!this.textures.exists("vc2AmbientGlow")) {
      const glowTexture = this.textures.createCanvas("vc2AmbientGlow", 12, 12);
      const glowCtx = glowTexture.context;
      const gradient = glowCtx.createRadialGradient(6, 6, 1, 6, 6, 6);
      gradient.addColorStop(0, "rgba(196, 231, 255, 0.95)");
      gradient.addColorStop(0.45, "rgba(124, 169, 255, 0.55)");
      gradient.addColorStop(1, "rgba(124, 169, 255, 0)");
      glowCtx.fillStyle = gradient;
      glowCtx.fillRect(0, 0, 12, 12);
      glowTexture.refresh();
    }

    if (!this.textures.exists("vc2AmbientLeaf")) {
      const leafTexture = this.textures.createCanvas("vc2AmbientLeaf", 12, 8);
      const leafCtx = leafTexture.context;
      leafCtx.fillStyle = "rgba(144, 170, 66, 0.95)";
      leafCtx.beginPath();
      leafCtx.ellipse(6, 4, 4.6, 2.4, -0.35, 0, Math.PI * 2);
      leafCtx.fill();
      leafCtx.strokeStyle = "rgba(102, 120, 39, 0.7)";
      leafCtx.lineWidth = 1;
      leafCtx.beginPath();
      leafCtx.moveTo(3.2, 5.2);
      leafCtx.lineTo(8.4, 2.6);
      leafCtx.stroke();
      leafTexture.refresh();
    }

    if (!this.textures.exists("vc2AmbientSteam")) {
      const steamTexture = this.textures.createCanvas("vc2AmbientSteam", 18, 18);
      const steamCtx = steamTexture.context;
      const steamGradient = steamCtx.createRadialGradient(9, 9, 2, 9, 9, 9);
      steamGradient.addColorStop(0, "rgba(232, 238, 255, 0.7)");
      steamGradient.addColorStop(0.6, "rgba(196, 205, 234, 0.32)");
      steamGradient.addColorStop(1, "rgba(196, 205, 234, 0)");
      steamCtx.fillStyle = steamGradient;
      steamCtx.beginPath();
      steamCtx.arc(9, 9, 9, 0, Math.PI * 2);
      steamCtx.fill();
      steamTexture.refresh();
    }

  }

  ensureCityNpcAnimations() {
    CITY_NPC_PATROLS.forEach((npc) => {
      ["down", "left", "right", "up"].forEach((dir, index) => {
        const walkKey = `${npc.key}-walk-${dir}`;
        if (!this.anims.exists(walkKey)) {
          this.anims.create({
            key: walkKey,
            frames: this.anims.generateFrameNumbers(npc.texture, {
              start: 4 * index,
              end: 4 * index + 3,
            }),
            frameRate: 6,
            repeat: -1,
          });
        }

        const idleKey = `${npc.key}-idle-${dir}`;
        if (!this.anims.exists(idleKey)) {
          this.anims.create({
            key: idleKey,
            frames: this.anims.generateFrameNumbers(npc.idleTexture, {
              start: 4 * index,
              end: 4 * index + 3,
            }),
            frameRate: 5,
            repeat: -1,
          });
        }
      });
    });
  }

  createCityPatrolNpcs() {
    CITY_NPC_PATROLS.forEach((config) => {
      const sprite = this.add
        .sprite(config.start.x, config.start.y, config.idleTexture, 0)
        .setScale(NPC_SCALE)
        .setDepth(1700);

      this.patrolNpcs.push({
        ...config,
        sprite,
        pathIndex: 1 % config.path.length,
        waitUntil: this.time.now + Phaser.Math.Between(300, 900),
        lastDirection: "down",
      });

      this.setCityNpcIdle(this.patrolNpcs[this.patrolNpcs.length - 1], "down");
    });
  }

  setCityNpcIdle(npc, direction = npc.lastDirection || "down") {
    npc.lastDirection = direction;
    const animKey = `${npc.key}-idle-${direction}`;
    if (npc.sprite.anims.currentAnim?.key !== animKey) {
      npc.sprite.play(animKey, true);
    }
  }

  createAmbientParticles() {
    const glowParticles = this.add.particles(0, 0, "vc2AmbientGlow", {
      x: { min: 144, max: 992 },
      y: { min: 960, max: 1712 },
      lifespan: { min: 3000, max: 4600 },
      speedX: { min: -9, max: 9 },
      speedY: { min: -20, max: -8 },
      scale: { start: 0.7, end: 0.14 },
      alpha: { start: 0.34, end: 0 },
      blendMode: "ADD",
      frequency: 440,
      quantity: 2,
    });
    glowParticles.setDepth(CITY_AMBIENT_PARTICLE_DEPTH);

    const leafParticles = this.add.particles(0, 0, "vc2AmbientLeaf", {
      x: { min: 1120, max: 1560 },
      y: { min: 704, max: 1888 },
      lifespan: { min: 4600, max: 6800 },
      speedX: { min: -18, max: 14 },
      speedY: { min: 7, max: 15 },
      rotate: { min: -22, max: 22 },
      angularVelocity: { min: -12, max: 12 },
      scale: { start: 0.66, end: 0.38 },
      alpha: { start: 0.34, end: 0 },
      frequency: 720,
      quantity: 2,
    });
    leafParticles.setDepth(CITY_AMBIENT_PARTICLE_DEPTH - 20);

    const westLeafParticles = this.add.particles(0, 0, "vc2AmbientLeaf", {
      x: { min: 24, max: 236 },
      y: { min: 1360, max: 1860 },
      lifespan: { min: 4300, max: 6200 },
      speedX: { min: -12, max: 10 },
      speedY: { min: 6, max: 12 },
      rotate: { min: -18, max: 18 },
      angularVelocity: { min: -9, max: 9 },
      scale: { start: 0.56, end: 0.32 },
      alpha: { start: 0.28, end: 0 },
      frequency: 980,
      quantity: 2,
    });
    westLeafParticles.setDepth(CITY_AMBIENT_PARTICLE_DEPTH - 24);

    const steamPoints = [
      ...CITY_PROP_SPECS.filter((prop) => ["kiosk", "bin"].includes(prop.tag)).map((prop) => ({
        x: prop.x + 10,
        y: prop.y - 8,
      })),
      { x: 1060, y: 1112 },
      { x: 700, y: 210 },
      { x: 312, y: 1594 },
    ];

    steamPoints.forEach((point) => {
      const steamParticles = this.add.particles(point.x, point.y, "vc2AmbientSteam", {
        lifespan: { min: 1800, max: 2600 },
        speedX: { min: -4, max: 4 },
        speedY: { min: -22, max: -12 },
        scale: { start: 0.52, end: 1.08 },
        alpha: { start: 0.22, end: 0 },
        rotate: { min: -8, max: 8 },
        frequency: 1150,
        quantity: 1,
      });
      steamParticles.setDepth(CITY_AMBIENT_PARTICLE_DEPTH - 10);
    });
  }

  setNpcInteractionTarget(npc) {
    if (this.currentDoor) {
      this.currentNpc = npc;
      return;
    }
    if (this.currentNpc === npc) return;

    this.currentNpc = npc;
    if (npc) {
      window.dispatchEvent(
        new CustomEvent("npc-proximity", { detail: npc.key }),
      );
      window.dispatchEvent(
        new CustomEvent("interact-proximity", { detail: true }),
      );
      window.dispatchEvent(
        new CustomEvent("door-name", {
          detail: npc.promptLabel || "Talk",
        }),
      );
      return;
    }

    window.dispatchEvent(new CustomEvent("npc-proximity", { detail: null }));
    window.dispatchEvent(
      new CustomEvent("interact-proximity", { detail: false }),
    );
    window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
  }

  drawCityProps() {
    CITY_PROP_SPECS.forEach((prop) => {
      this.add
        .sprite(prop.x, prop.y, "vc2CityProps", prop.frame)
        .setOrigin(0, 0)
        .setDepth(CITY_PROP_DEPTH);
    });
  }

  canPlaceCityProp(
    grassLayer,
    sidewalkLayer,
    roadLayer,
    buildingLayer,
    customBuildingLayer,
    doorLayer,
    prop,
  ) {
    const baseX = Math.floor((prop.x + TILE_SIZE / 2) / TILE_SIZE);
    const baseY = Math.floor((prop.y + TILE_SIZE - 2) / TILE_SIZE);
    if (baseX < 0 || baseY < 0) return false;

    const width = grassLayer?.width || sidewalkLayer?.width || roadLayer?.width || 0;
    const height = grassLayer?.height || sidewalkLayer?.height || roadLayer?.height || 0;
    if (baseX >= width || baseY >= height) return false;

    const index = baseY * width + baseX;
    const onWalkable = Boolean(grassLayer?.data?.[index] || sidewalkLayer?.data?.[index]);
    const onRoad = Boolean(roadLayer?.data?.[index]);
    const onBuilding = Boolean(buildingLayer?.data?.[index] || customBuildingLayer?.data?.[index]);
    const onDoor = Boolean(doorLayer?.data?.[index]);

    if (!onWalkable || onRoad || onBuilding || onDoor) return false;

    const tooCloseToDoor = Object.values(BUILDING_FACADES).some(({ door }) => (
      Math.abs((prop.x + TILE_SIZE / 2) - (door.x + TILE_SIZE / 2)) < 64
      && Math.abs((prop.y + TILE_SIZE) - (door.y + TILE_SIZE)) < 64
    ));

    return !tooCloseToDoor;
  }

  drawCityTrees() {
    const shadowGfx = this.add.graphics().setDepth(1180);
    const grassLayer = this.getLayerByName("Grass");
    const buildingLayer = this.getLayerByName("Buildings");
    const customBuildingLayer = this.getLayerByName("CustomBuildings");
    if (!grassLayer) return;

    const previewTreeSpecs = this.getTreePreviewSpecs();
    const tmxTreeSpecs = this.getTmxTreeSpecs();
    const treeSpecs = previewTreeSpecs.length > 0
      ? previewTreeSpecs
      : tmxTreeSpecs.length > 0
      ? tmxTreeSpecs
      : [
        ...CITY_TREE_SPECS,
        ...this.buildFrontBuildingTreeSpecs(),
      ];

    treeSpecs.forEach((tree) => {
      if (tree.source === "preview") {
        this.drawCityTreeInstance(shadowGfx, tree);
        return;
      }

      if (!this.canPlaceTree(grassLayer, buildingLayer, customBuildingLayer, tree.kind, tree.x, tree.y)) {
        return;
      }

      this.drawCityTreeInstance(shadowGfx, tree);
    });
  }

  getTmxTreeSpecs() {
    const treeLayer = this.getObjectLayerByName("Trees");
    if (!treeLayer?.objects?.length) return [];

    return treeLayer.objects
      .map((object, index) => this.buildTreeSpecFromObject(object, index))
      .filter(Boolean);
  }

  getTreePreviewSpecs() {
    const previewLayer = this.getLayerByName("TreePreview");
    const plantFirstgid = this.getTreePreviewPlantFirstgid();
    if (!previewLayer?.data?.length || !plantFirstgid) return [];

    const candidates = this.buildTreePreviewCandidates(previewLayer, plantFirstgid);
    if (candidates.length === 0) {
      return [];
    }

    return this.resolveSupportedTreePreviewCandidates(previewLayer, candidates);
  }

  buildTreePreviewCandidates(previewLayer, plantFirstgid) {
    const candidates = [];
    const { width, height, data } = previewLayer;

    for (let tileY = 0; tileY < height; tileY += 1) {
      for (let tileX = 0; tileX < width; tileX += 1) {
        const gid = data[tileY * width + tileX];
        if (!gid) continue;

        TREE_PREVIEW_PATTERNS.forEach((pattern) => {
          if (gid !== plantFirstgid + pattern.localOffset) return;

          const cells = [];
          for (let dy = 0; dy < pattern.heightTiles; dy += 1) {
            for (let dx = 0; dx < pattern.widthTiles; dx += 1) {
              const x = tileX + dx;
              const y = tileY + dy;
              if (x >= width || y >= height) continue;

              cells.push({
                x,
                y,
                expectedGid:
                  plantFirstgid
                  + pattern.localOffset
                  + dx
                  + dy * TREE_PREVIEW_TILESET_COLUMNS,
              });
            }
          }

          candidates.push({
            id: `preview-tree-${pattern.kind}-${tileX}-${tileY}`,
            kind: pattern.kind,
            source: "preview",
            x: tileX * TILE_SIZE,
            y: tileY * TILE_SIZE,
            cells,
          });
        });
      }
    }

    return candidates;
  }

  resolveSupportedTreePreviewCandidates(previewLayer, candidates) {
    const activeIds = new Set(candidates.map((candidate) => candidate.id));
    let changed = true;

    while (changed) {
      changed = false;
      const coverage = new Map();

      for (const candidate of candidates) {
        if (!activeIds.has(candidate.id)) continue;

        for (const cell of candidate.cells) {
          const key = `${cell.x},${cell.y}`;
          if (!coverage.has(key)) {
            coverage.set(key, new Set());
          }
          coverage.get(key).add(cell.expectedGid);
        }
      }

      for (const candidate of candidates) {
        if (!activeIds.has(candidate.id)) continue;

        let supported = true;
        for (const cell of candidate.cells) {
          const actualGid = previewLayer.data[cell.y * previewLayer.width + cell.x];
          if (actualGid === cell.expectedGid) {
            continue;
          }

          if (!coverage.get(`${cell.x},${cell.y}`)?.has(actualGid)) {
            supported = false;
            break;
          }
        }

        if (!supported) {
          activeIds.delete(candidate.id);
          changed = true;
        }
      }
    }

    return candidates.filter((candidate) => activeIds.has(candidate.id));
  }

  getTreePreviewPlantFirstgid() {
    const matchingTilesets = (this.mapSource?.tilesets || [])
      .filter((tileset) => tileset.basename === "plant.tsx")
      .map((tileset) => tileset.firstgid)
      .sort((a, b) => a - b);

    return matchingTilesets.at(-1) || null;
  }

  buildTreeSpecFromObject(object, index) {
    const rawKind = (
      object.properties?.kind
      || object.type
      || object.name
      || "small"
    ).toLowerCase();

    const kind = ["large", "medium", "small"].includes(rawKind)
      ? rawKind
      : "small";
    const rect = TREE_TEXTURE_RECTS[kind];
    const pivot = TREE_PIVOT_POINTS[kind] || {
      x: rect.width / 2,
      y: rect.height,
    };

    const anchorX = object.width > 0 ? object.x + object.width / 2 : object.x;
    const anchorY = object.height > 0 ? object.y + object.height : object.y;

    return {
      id: object.id || `tmx-tree-${index}`,
      kind,
      x: Math.round(anchorX - pivot.x),
      y: Math.round(anchorY - rect.height + 6),
    };
  }

  drawCityTreeInstance(shadowGfx, tree) {
    const rect = TREE_TEXTURE_RECTS[tree.kind];
    shadowGfx.fillStyle(0x16331d, 0.24);
    shadowGfx.fillEllipse(
      tree.x + rect.width / 2,
      tree.y + rect.height - 18,
      Math.max(54, rect.width - 34),
      24,
    );
    this.drawTreeSprite(tree.kind, tree.x, tree.y);
    this.addTreeCollision(tree.kind, tree.x, tree.y);
  }

  addTreeCollision(kind, x, y) {
    const rect = TREE_TEXTURE_RECTS[kind];
    const pivot = TREE_PIVOT_POINTS[kind] || {
      x: rect.width / 2,
      y: rect.height,
    };
    const collision = TREE_COLLISION_SPECS[kind] || TREE_COLLISION_SPECS.medium;
    const trunkX = x + pivot.x;
    const trunkBottomY = y + rect.height - 6;

    this.matter.add.rectangle(
      trunkX,
      trunkBottomY - collision.height / 2,
      collision.width,
      collision.height,
      {
        isStatic: true,
        label: "building",
      },
    );
  }

  buildFrontBuildingTreeSpecs() {
    const simpleSpecs = SIMPLE_BUILDINGS.flatMap((building) => {
      const width = building.widthTiles * TILE_SIZE;
      const height = (building.roofRows + building.baseRows) * TILE_SIZE;
      return this.buildFrontTreesForFootprint(building.id, building.x, building.y, width, height);
    });

    const customSpecs = CUSTOM_BUILDINGS.flatMap((building) => (
      this.buildFrontTreesForFootprint(
        building.id,
        building.x,
        building.y,
        building.width,
        building.height,
      )
    ));

    return [...simpleSpecs, ...customSpecs];
  }

  buildFrontTreesForFootprint(buildingId, x, y, width, height) {
    const bottomY = y + height;
    const candidates = [
      { kind: width >= 320 ? "medium" : "small", fraction: 0.22 },
      { kind: "small", fraction: 0.5 },
      { kind: width >= 320 ? "medium" : "small", fraction: 0.78 },
    ];

    return candidates.map((candidate) => {
      const rect = TREE_TEXTURE_RECTS[candidate.kind];
      const pivot = TREE_PIVOT_POINTS[candidate.kind] || {
        x: rect.width / 2,
        y: rect.height,
      };
      const trunkX = x + width * candidate.fraction;
      const trunkY = bottomY + 18;

      return {
        id: `${buildingId}-${candidate.kind}-${candidate.fraction}`,
        kind: candidate.kind,
        x: Math.round(trunkX - pivot.x),
        y: Math.round(trunkY - rect.height + 6),
      };
    });
  }

  canPlaceTree(grassLayer, buildingLayer, customBuildingLayer, kind, x, y) {
    const rect = TREE_TEXTURE_RECTS[kind];
    const pivot = TREE_PIVOT_POINTS[kind] || {
      x: rect.width / 2,
      y: rect.height,
    };
    const baseTileX = Math.floor((x + pivot.x) / TILE_SIZE);
    const baseTileY = Math.floor((y + rect.height - 6) / TILE_SIZE);
    const leftTileX = Math.floor((x + pivot.x - 16) / TILE_SIZE);
    const rightTileX = Math.floor((x + pivot.x + 16) / TILE_SIZE);
    const footprintTiles = [leftTileX, baseTileX, rightTileX];

    const hasGrassFootprint = footprintTiles.every((tx) => {
      if (tx < 0 || tx >= grassLayer.width || baseTileY < 0 || baseTileY >= grassLayer.height) {
        return false;
      }
      return Boolean(grassLayer.data[baseTileY * grassLayer.width + tx]);
    });

    if (!hasGrassFootprint) return false;

    const overlapsBuilding = footprintTiles.some((tx) => {
      const tileIndex = baseTileY * grassLayer.width + tx;
      return Boolean(buildingLayer?.data?.[tileIndex] || customBuildingLayer?.data?.[tileIndex]);
    });

    if (overlapsBuilding) return false;

    const trunkX = x + pivot.x;
    const trunkY = y + rect.height - 6;
    const tooCloseToDoor = Object.values(BUILDING_FACADES).some(({ door }) => (
      Math.abs(trunkX - (door.x + TILE_SIZE / 2)) < 88
      && Math.abs(trunkY - (door.y + TILE_SIZE)) < 96
    ));

    return !tooCloseToDoor;
  }

  drawTreeSprite(kind, x, y) {
    const rect = TREE_TEXTURE_RECTS[kind];
    const pivot = TREE_PIVOT_POINTS[kind] || {
      x: rect.width / 2,
      y: rect.height,
    };
    const baseHeight = TREE_LOCKED_BASE_HEIGHT[kind] || 20;
    const canopyHeight = rect.height - baseHeight;
    const seamX = x + pivot.x;
    const seamY = y + canopyHeight;

    this.add
      .image(x, y + canopyHeight, `vc2-tree-${kind}-base`)
      .setOrigin(0, 0)
      .setDepth(CITY_TREE_BASE_DEPTH + 1);

    const container = this.add.container(seamX, seamY).setDepth(CITY_TREE_BASE_DEPTH);
    const canopy = this.add
      .image(-pivot.x, -canopyHeight, `vc2-tree-${kind}-canopy`)
      .setOrigin(0, 0);
    container.add(canopy);

    this.treeSprites.push({
      kind,
      sprite: canopy,
      restY: -canopyHeight,
    });
  }

  startTreeWindSway() {
    this.treeSprites.forEach(({ kind, sprite, restY }, index) => {
      const sway = TREE_SWAY_SETTINGS[kind] || TREE_SWAY_SETTINGS.medium;
      const offset = (index % 5) * 170;

      this.tweens.add({
        targets: sprite,
        y: { from: restY, to: restY + sway.bob },
        duration: sway.duration + offset,
        ease: "Sine.InOut",
        yoyo: true,
        repeat: -1,
        delay: offset,
      });
    });
  }

  updateCityPatrolNpcs() {
    const playerLeft = this.player.x - 18;
    const playerTop = this.player.y - 28;
    const playerWidth = 36;
    const playerHeight = 52;
    let nearestNpc = null;
    let nearestDistanceSq = Infinity;

    this.patrolNpcs.forEach((npc) => {
      const npcLeft = npc.sprite.x - 14;
      const npcTop = npc.sprite.y - 25;
      const npcWidth = 28;
      const npcHeight = 26;

      const touchingPlayer = !(
        playerLeft + playerWidth < npcLeft
        || npcLeft + npcWidth < playerLeft
        || playerTop + playerHeight < npcTop
        || npcTop + npcHeight < playerTop
      );

      if (touchingPlayer) {
        const distanceSq =
          (this.player.x - npc.sprite.x) ** 2 + (this.player.y - npc.sprite.y) ** 2;
        if (distanceSq < nearestDistanceSq) {
          nearestDistanceSq = distanceSq;
          nearestNpc = npc;
        }
        this.setCityNpcIdle(npc);
        return;
      }

      if (npc.waitUntil > this.time.now) {
        this.setCityNpcIdle(npc);
        return;
      }

      const target = npc.path[npc.pathIndex];
      if (!target) return;

      const dx = target.x - npc.sprite.x;
      const dy = target.y - npc.sprite.y;
      const distance = Math.hypot(dx, dy);

      if (distance <= 1.5) {
        npc.sprite.setPosition(target.x, target.y);
        npc.pathIndex = (npc.pathIndex + 1) % npc.path.length;
        npc.waitUntil = this.time.now + NPC_WAIT_MS;
        this.setCityNpcIdle(npc);
        return;
      }

      const vx = (dx / distance) * NPC_MOVE_SPEED;
      const vy = (dy / distance) * NPC_MOVE_SPEED;

      npc.sprite.x += vx;
      npc.sprite.y += vy;
      npc.sprite.setDepth(1700);

      if (Math.abs(vy) > Math.abs(vx)) {
        npc.lastDirection = vy < 0 ? "up" : "down";
        npc.sprite.anims.play(
          vy < 0 ? `${npc.key}-walk-up` : `${npc.key}-walk-down`,
          true,
        );
      } else if (vx < 0) {
        npc.lastDirection = "left";
        npc.sprite.anims.play(`${npc.key}-walk-left`, true);
      } else {
        npc.lastDirection = "right";
        npc.sprite.anims.play(`${npc.key}-walk-right`, true);
      }
    });

    this.setNpcInteractionTarget(nearestNpc);
  }

  createCollisionBodiesFromSource() {
    const collisionLayer = this.getObjectLayerByName("Collisions");
    if (!collisionLayer) return;

    collisionLayer.objects.forEach((object) => {
      const isExit = object.name === "exit";
      this.matter.add.rectangle(
        object.x + object.width / 2,
        object.y + object.height / 2,
        object.width,
        object.height,
        {
          isStatic: true,
          isSensor: ENABLE_VOID_CITY_2_EXITS && isExit,
          label: ENABLE_VOID_CITY_2_EXITS && isExit ? "exit" : "building",
        },
      );
    });
  }

  createExitPortalVisual() {
    if (!ENABLE_VOID_CITY_2_EXITS) return;

    const collisionLayer = this.getObjectLayerByName("Collisions");
    const exit = collisionLayer?.objects?.find((object) => object.name === "exit");
    if (!exit) return;

    const centerX = exit.x + exit.width / 2;
    const centerY = exit.y + exit.height / 2;

    const glow = this.add.graphics().setDepth(3000);
    glow.fillStyle(0x79c9ff, 0.18);
    glow.fillCircle(centerX, centerY, 52);
    glow.fillStyle(0x9ee6ff, 0.3);
    glow.fillCircle(centerX, centerY, 30);
    glow.lineStyle(3, 0xe6fbff, 0.95);
    glow.strokeCircle(centerX, centerY, 18);

    this.add
      .text(centerX, centerY - 40, "Return", {
        font: "16px Arial",
        fill: "#ecfbff",
        stroke: "#16364a",
        strokeThickness: 4,
      })
      .setOrigin(0.5)
      .setDepth(3001);
  }

  createWhisperingForestPortalVisual() {
    if (this.whisperingForestPortalVisual || this.whisperingForestPortalSensor) {
      return;
    }

    const centerX = WHISPERING_FOREST_PORTAL.x + WHISPERING_FOREST_PORTAL.width / 2;
    const centerY = WHISPERING_FOREST_PORTAL.y + WHISPERING_FOREST_PORTAL.height / 2;

    this.whisperingForestPortalSensor = this.matter.add.rectangle(
      centerX,
      centerY,
      WHISPERING_FOREST_PORTAL.width,
      WHISPERING_FOREST_PORTAL.height,
      {
        isStatic: true,
        isSensor: true,
        label: WHISPERING_FOREST_PORTAL_LABEL,
      },
    );
    this.whisperingForestPortalBounds = getWhisperingForestPortalBounds();

    const portal = this.add.container(centerX, centerY).setDepth(3000);
    const glow = this.add.graphics();
    glow.fillStyle(0x3cf18d, 0.18);
    glow.fillCircle(0, 0, 46);
    glow.fillStyle(0x68ffd1, 0.32);
    glow.fillCircle(0, 0, 28);
    glow.lineStyle(3, 0xc5fff0, 0.92);
    glow.strokeCircle(0, 0, 18);

    const rune = this.add.text(0, -2, "WF", {
      font: "bold 18px Arial",
      fill: "#effff8",
      stroke: "#0b4c2e",
      strokeThickness: 4,
    }).setOrigin(0.5);

    const label = this.add.text(0, 40, "Whispering Forest", {
      font: "12px Arial",
      fill: "#e9fff3",
      stroke: "#123323",
      strokeThickness: 3,
    }).setOrigin(0.5);

    portal.add([glow, rune, label]);
    this.whisperingForestPortalVisual = portal;
    this.whisperingForestPortalTween = this.tweens.add({
      targets: portal,
      y: centerY - 6,
      duration: 1400,
      ease: "Sine.InOut",
      yoyo: true,
      repeat: -1,
    });
    this.whisperingForestPortalVisible = true;
  }

  destroyWhisperingForestPortalVisual() {
    this.whisperingForestPortalTween?.remove?.();
    this.whisperingForestPortalTween = null;
    this.whisperingForestPortalVisual?.destroy?.();
    this.whisperingForestPortalVisual = null;

    if (this.whisperingForestPortalSensor) {
      try {
        this.matter?.world?.remove?.(this.whisperingForestPortalSensor);
      } catch {}
    }

    this.whisperingForestPortalSensor = null;
    this.whisperingForestPortalBounds = null;
    this.whisperingForestPortalVisible = false;

    if (this.currentDoor === WHISPERING_FOREST_PORTAL_LABEL) {
      this.currentDoor = null;
      if (this.currentNpc) {
        this.setNpcInteractionTarget(this.currentNpc);
      } else {
        window.dispatchEvent(
          new CustomEvent("interact-proximity", { detail: false }),
        );
        window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
      }
    }
  }

  syncWhisperingForestPortalPrompt() {
    if (!this.whisperingForestPortalBounds || !this.player) return;
    if (this.currentDoor && this.currentDoor !== WHISPERING_FOREST_PORTAL_LABEL) return;

    const isInsidePortal = Phaser.Geom.Rectangle.Contains(
      this.whisperingForestPortalBounds,
      this.player.x,
      this.player.y,
    );

    if (isInsidePortal) {
      this.currentDoor = WHISPERING_FOREST_PORTAL_LABEL;
      window.dispatchEvent(
        new CustomEvent("interact-proximity", { detail: true }),
      );
      window.dispatchEvent(
        new CustomEvent("door-name", { detail: "Enter Whispering Forest" }),
      );
      return;
    }

    if (this.currentDoor === WHISPERING_FOREST_PORTAL_LABEL) {
      this.currentDoor = null;
      if (this.currentNpc) {
        this.setNpcInteractionTarget(this.currentNpc);
      } else {
        window.dispatchEvent(
          new CustomEvent("interact-proximity", { detail: false }),
        );
        window.dispatchEvent(new CustomEvent("door-name", { detail: null }));
      }
    }
  }

  syncWhisperingForestPortalVisual() {
    const shouldShowPortal = this.isWhisperingForestUnlocked();

    if (!shouldShowPortal) {
      this.destroyWhisperingForestPortalVisual();
      return;
    }

    this.createWhisperingForestPortalVisual();
    this.syncWhisperingForestPortalPrompt();
  }

  createDoorSpritesFromSource() {
    const doorLayer = this.getLayerByName("Doors");
    if (!doorLayer) return;

    doorLayer.data.forEach((gid, index) => {
      if (!gid) return;
      const resolved = this.resolveTilesetForGid(gid);
      if (!resolved) return;

      const tx = index % doorLayer.width;
      const ty = Math.floor(index / doorLayer.width);
      const x = tx * TILE_SIZE;
      const y = ty * TILE_SIZE;

      if (
        resolved.textureKey === "vc2CityFacade"
        && resolved.frame === DOOR_CLOSED_FRAME
      ) {
        const id = `door-${tx}-${ty}`;
        const sprite = this.add
          .sprite(x, y, resolved.textureKey, resolved.frame)
          .setOrigin(0, 0)
          .setDepth(1450);

        this.simpleDoors[id] = {
          id,
          sprite,
          frameSprites: [],
          isOpen: false,
          isAnimating: false,
          windowSprite: null,
        };

        if (ENABLE_VOID_CITY_2_BUILDING_DOORS) {
          this.matter.add.rectangle(
            x + TILE_SIZE / 2,
            y + TILE_SIZE + 10,
            TILE_SIZE + 8,
            TILE_SIZE,
            {
              isStatic: true,
              isSensor: true,
              label: `simpleDoor:${id}`,
            },
          );
        }
      } else {
        this.add
          .sprite(x, y, resolved.textureKey, resolved.frame)
          .setOrigin(0, 0)
          .setDepth(1435);
      }
    });
  }

  createBuildingFacades() {
    Object.entries(BUILDING_FACADES).forEach(([id, facade]) => {
      const windowSprite = facade.window
        ? this.add
          .sprite(
            facade.window.x,
            facade.window.y,
            "vc2CityFacade",
            FACADE_FRAMES.windowSingle,
          )
          .setOrigin(0, 0)
          .setDepth(1400)
        : null;

      const doorSprite = this.add
        .sprite(
          facade.door.x,
          facade.door.y,
          "vc2CityFacade",
          FACADE_FRAMES.doorSequence[0],
        )
        .setOrigin(0, 0)
        .setDepth(1450);

      const frameSprites = [];
      FACADE_FRAMES.doorFrameTop.forEach((frame, index) => {
        frameSprites.push(
          this.add
            .sprite(
              facade.door.x + (index - 1) * TILE_SIZE,
              facade.door.y - TILE_SIZE,
              "vc2CityFacade",
              frame,
            )
            .setOrigin(0, 0)
            .setDepth(1435),
        );
      });
      FACADE_FRAMES.doorFrameBottom.forEach((frame, index) => {
        frameSprites.push(
          this.add
            .sprite(
              facade.door.x + (index - 1) * TILE_SIZE,
              facade.door.y,
              "vc2CityFacade",
              frame,
            )
            .setOrigin(0, 0)
            .setDepth(1435),
        );
      });

      this.simpleDoors[id] = {
        id,
        sprite: doorSprite,
        frameSprites,
        isOpen: false,
        isAnimating: false,
        windowSprite,
      };

      this.matter.add.rectangle(
        facade.door.x + TILE_SIZE / 2,
        facade.door.y + TILE_SIZE + 10,
        TILE_SIZE + 8,
        TILE_SIZE,
        {
          isStatic: true,
          isSensor: true,
          label: `simpleDoor:${id}`,
        },
      );
    });
  }

  openSimpleDoor(id, onComplete = null) {
    const door = this.simpleDoors[id];
    if (!door || door.isOpen || door.isAnimating) return;

    door.isAnimating = true;
    AudioManager.playSFX("door");

    FACADE_FRAMES.doorSequence.forEach((frame, index) => {
      this.time.delayedCall(index * 90, () => {
        door.sprite.setFrame(frame);
        if (index === FACADE_FRAMES.doorSequence.length - 1) {
          door.isOpen = true;
          door.isAnimating = false;
          if (typeof onComplete === "function") {
            onComplete();
          }
        }
      });
    });
  }

  createReturnPortal() {
    this.matter.add.rectangle(136, 112, 144, 80, {
      isStatic: true,
      isSensor: true,
      label: "exit",
    });

    const glow = this.add.graphics().setDepth(3000);
    glow.fillStyle(0x79c9ff, 0.18);
    glow.fillCircle(136, 112, 52);
    glow.fillStyle(0x9ee6ff, 0.3);
    glow.fillCircle(136, 112, 30);
    glow.lineStyle(3, 0xe6fbff, 0.95);
    glow.strokeCircle(136, 112, 18);

    this.add
      .text(136, 72, "Return", {
        font: "16px Arial",
        fill: "#ecfbff",
        stroke: "#16364a",
        strokeThickness: 4,
      })
      .setOrigin(0.5)
      .setDepth(3001);
  }

  drawBaseMapFromTemplate() {
    const templateSource = this.textures.get("vc2Template")?.getSourceImage();
    if (!templateSource) return;

    const canvas = document.createElement("canvas");
    canvas.width = templateSource.width;
    canvas.height = templateSource.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(templateSource, 0, 0);

    const rt = this.make.renderTexture({
      width: MAP_WIDTH,
      height: MAP_HEIGHT,
      add: false,
    });

    const tileTypes = [];
    for (let ty = 0; ty < MAP_HEIGHT / TILE_SIZE; ty += 1) {
      tileTypes[ty] = [];
      for (let tx = 0; tx < MAP_WIDTH / TILE_SIZE; tx += 1) {
        const type = this.classifyTemplateTile(ctx, tx, ty);
        tileTypes[ty][tx] = type;
        if (type === "void") continue;
        const textureKey = type === "grass" ? "vc2ForestGrass" : "vc2CityVoid";
        rt.drawFrame(textureKey, BASE_FRAMES[type], tx * TILE_SIZE, ty * TILE_SIZE);
      }
    }

    this.applySidewalkOverrides(rt, tileTypes);
    this.applyBuildingPads(rt, tileTypes);
    this.cleanupSidewalkBleed(rt, tileTypes);
    this.applyRoadCleanup(rt, tileTypes);

    if (this.textures.exists("vc2BaseMap")) {
      this.textures.remove("vc2BaseMap");
    }
    rt.saveTexture("vc2BaseMap");
    this.add.image(0, 0, "vc2BaseMap").setOrigin(0).setDepth(1);

    this.drawTemplateMarkings(ctx, tileTypes);

    this.add
      .text(56, 48, "Void City 2", {
        font: "28px Arial",
        fill: "#eef2ff",
        stroke: "#1c1f48",
        strokeThickness: 6,
      })
      .setOrigin(0, 0.5)
      .setDepth(3001)
      .setScrollFactor(0.15);
  }

  drawBuildingShells() {
    const rt = this.make.renderTexture({
      width: MAP_WIDTH,
      height: MAP_HEIGHT,
      add: false,
    });

    SIMPLE_BUILDINGS.forEach((building) => {
      this.drawSimpleBuilding(rt, building);
      this.addBuildingCollision({
        x: building.x,
        y: building.y,
        width: building.widthTiles * TILE_SIZE,
        height: (building.roofRows + building.baseRows) * TILE_SIZE,
      });
    });

    if (this.textures.exists("vc2BuildingShells")) {
      this.textures.remove("vc2BuildingShells");
    }
    rt.saveTexture("vc2BuildingShells");
    this.add.image(0, 0, "vc2BuildingShells").setOrigin(0).setDepth(1200);

    this.drawCustomBuildings();
  }

  drawCustomBuildings() {
    const source = this.textures.get("vc2CustomBuildings")?.getSourceImage();
    if (!source) return;

    CUSTOM_BUILDINGS.forEach((building) => {
      const textureKey = `vc2CustomBuilding-${building.id}`;
      if (this.textures.exists(textureKey)) {
        this.textures.remove(textureKey);
      }

      const canvasTexture = this.textures.createCanvas(
        textureKey,
        building.width,
        building.height,
      );
      const ctx = canvasTexture.getContext();
      ctx.clearRect(0, 0, building.width, building.height);
      ctx.drawImage(
        source,
        building.sourceX,
        building.sourceY,
        building.width,
        building.height,
        0,
        0,
        building.width,
        building.height,
      );
      canvasTexture.refresh();

      this.add
        .image(building.x, building.y, textureKey)
        .setOrigin(0)
        .setDepth(1225);

      building.collisions.forEach((part) => {
        this.addBuildingCollision({
          x: building.x + part.x - part.width / 2,
          y: building.y + part.y - part.height / 2,
          width: part.width,
          height: part.height,
        });
      });
    });
  }

  drawSimpleBuilding(rt, building) {
    for (let row = 0; row < building.roofRows; row += 1) {
      for (let col = 0; col < building.widthTiles; col += 1) {
        rt.drawFrame(
          "vc2CityShell",
          this.resolveRepeatedFrame(
            SIMPLE_BUILDING_FRAMES.roof,
            row,
            col,
            building.widthTiles,
            building.roofRows,
          ),
          building.x + col * TILE_SIZE,
          building.y + row * TILE_SIZE,
        );
      }
    }

    for (let row = 0; row < building.baseRows; row += 1) {
      for (let col = 0; col < building.widthTiles; col += 1) {
        rt.drawFrame(
          "vc2CityShell",
          this.resolveRepeatedFrame(
            SIMPLE_BUILDING_FRAMES.base,
            row,
            col,
            building.widthTiles,
            building.baseRows,
          ),
          building.x + col * TILE_SIZE,
          building.y + (building.roofRows + row) * TILE_SIZE,
        );
      }
    }
  }

  resolveRepeatedFrame(frameGrid, row, col, totalCols, totalRows) {
    const rowCount = frameGrid.length;
    const resolvedCol =
      col <= 0 ? 0 : col >= totalCols - 1 ? 2 : 1;
    let resolvedRow = 0;

    if (row <= 0 || rowCount === 1) {
      resolvedRow = 0;
    } else if (row >= totalRows - 1) {
      resolvedRow = rowCount - 1;
    } else if (rowCount === 2) {
      resolvedRow = 0;
    } else {
      resolvedRow = 1;
    }

    return frameGrid[resolvedRow][resolvedCol];
  }

  addBuildingCollision(part) {
    const centerX = part.x + part.width / 2;
    const centerY = part.y + part.height / 2;
    this.matter.add.rectangle(centerX, centerY, part.width, part.height, {
      isStatic: true,
      label: "building",
    });
  }

  classifyTemplateTile(ctx, tx, ty) {
    let voidCount = 0;
    let grassCount = 0;
    let roadCount = 0;
    let sidewalkCount = 0;

    for (let py = 4; py < TILE_SIZE; py += 8) {
      for (let px = 4; px < TILE_SIZE; px += 8) {
        const x = tx * TILE_SIZE + px;
        const y = ty * TILE_SIZE + py;
        const [r, g, b, a] = ctx.getImageData(x, y, 1, 1).data;

        if (a < 10) {
          voidCount += 1;
          continue;
        }

        const sample = { r, g, b };
        const roadDist = colorDistanceSq(sample, TARGET_COLORS.road);
        const grassDist = colorDistanceSq(sample, TARGET_COLORS.grass);
        const sidewalkDist = colorDistanceSq(sample, TARGET_COLORS.sidewalk);
        const whiteDist = colorDistanceSq(sample, TARGET_COLORS.white);
        const yellowDist = colorDistanceSq(sample, TARGET_COLORS.yellow);

        if (whiteDist < 2400 || yellowDist < 5000) {
          roadCount += 1;
        } else if (roadDist < grassDist && roadDist < sidewalkDist) {
          roadCount += 1;
        } else if (grassDist < sidewalkDist) {
          grassCount += 1;
        } else {
          sidewalkCount += 1;
        }
      }
    }

    if (voidCount >= 8 && grassCount + roadCount + sidewalkCount === 0) {
      return "void";
    }
    if (roadCount >= grassCount && roadCount >= sidewalkCount) {
      return "road";
    }
    if (grassCount >= sidewalkCount) {
      return "grass";
    }
    return "sidewalk";
  }

  drawTemplateMarkings(ctx, tileTypes) {
    const g = this.add.graphics().setDepth(2);

    for (let y = 0; y < MAP_HEIGHT; y += 4) {
      for (let x = 0; x < MAP_WIDTH; x += 4) {
        if (this.isInsideSimpleBuilding(x, y)) continue;
        const tx = Math.floor(x / TILE_SIZE);
        const ty = Math.floor(y / TILE_SIZE);
        if (tileTypes?.[ty]?.[tx] !== "road") continue;

        const [r, gr, b, a] = ctx.getImageData(x, y, 1, 1).data;
        if (a < 10) continue;

        const sample = { r, g: gr, b };
        const whiteDist = colorDistanceSq(sample, TARGET_COLORS.white);
        const yellowDist = colorDistanceSq(sample, TARGET_COLORS.yellow);

        if (whiteDist < 2600) {
          g.fillStyle(0xf3eef6, 0.95);
          g.fillRect(x, y, 4, 4);
        } else if (yellowDist < 5200) {
          g.fillStyle(0xf0df3d, 0.95);
          g.fillRect(x, y, 4, 4);
        }
      }
    }
  }

  applySidewalkOverrides(rt, tileTypes) {
    SIDEWALK_OVERRIDE_RECTS.forEach((rect) => {
      const startTx = Math.floor(rect.x / TILE_SIZE);
      const startTy = Math.floor(rect.y / TILE_SIZE);
      const endTx = Math.ceil((rect.x + rect.width) / TILE_SIZE);
      const endTy = Math.ceil((rect.y + rect.height) / TILE_SIZE);

      for (let ty = startTy; ty < endTy; ty += 1) {
        for (let tx = startTx; tx < endTx; tx += 1) {
          if (!tileTypes[ty] || tileTypes[ty][tx] === "void") continue;
          tileTypes[ty][tx] = "sidewalk";
          rt.drawFrame(
            "vc2CityVoid",
            BASE_FRAMES.sidewalk,
            tx * TILE_SIZE,
            ty * TILE_SIZE,
          );
        }
      }
    });
  }

  applyBuildingPads(rt, tileTypes) {
    SIMPLE_BUILDINGS.forEach((building) => {
      const startTx = Math.floor(building.x / TILE_SIZE);
      const startTy = Math.floor(building.y / TILE_SIZE);
      const endTx = startTx + building.widthTiles;
      const endTy = startTy + building.roofRows + building.baseRows;

      for (let ty = startTy; ty < endTy; ty += 1) {
        for (let tx = startTx; tx < endTx; tx += 1) {
          if (!tileTypes[ty] || tileTypes[ty][tx] === "void") continue;
          tileTypes[ty][tx] = "sidewalk";
          rt.drawFrame(
            "vc2CityVoid",
            BASE_FRAMES.sidewalk,
            tx * TILE_SIZE,
            ty * TILE_SIZE,
          );
        }
      }
    });

    CUSTOM_BUILDINGS.forEach((building) => {
      const startTx = Math.floor(building.x / TILE_SIZE);
      const startTy = Math.floor(building.y / TILE_SIZE);
      const endTx = Math.ceil((building.x + building.width) / TILE_SIZE);
      const endTy = Math.ceil((building.y + building.height) / TILE_SIZE);

      for (let ty = startTy; ty < endTy; ty += 1) {
        for (let tx = startTx; tx < endTx; tx += 1) {
          if (!tileTypes[ty] || tileTypes[ty][tx] === "void") continue;
          tileTypes[ty][tx] = "sidewalk";
          rt.drawFrame(
            "vc2CityVoid",
            BASE_FRAMES.sidewalk,
            tx * TILE_SIZE,
            ty * TILE_SIZE,
          );
        }
      }
    });
  }

  cleanupSidewalkBleed(rt, tileTypes) {
    const updates = [];

    for (let ty = 1; ty < tileTypes.length - 1; ty += 1) {
      for (let tx = 1; tx < tileTypes[ty].length - 1; tx += 1) {
        if (tileTypes[ty]?.[tx] !== "road") continue;

        const neighbors = [
          tileTypes[ty - 1]?.[tx],
          tileTypes[ty + 1]?.[tx],
          tileTypes[ty]?.[tx - 1],
          tileTypes[ty]?.[tx + 1],
        ];

        const sidewalkNeighbors = neighbors.filter((type) => type === "sidewalk").length;
        const roadNeighbors = neighbors.filter((type) => type === "road").length;

        // Convert isolated road specks that ended up enclosed by sidewalk repaint zones.
        if (sidewalkNeighbors >= 3 && roadNeighbors <= 1) {
          updates.push({ tx, ty });
        }
      }
    }

    updates.forEach(({ tx, ty }) => {
      tileTypes[ty][tx] = "sidewalk";
      rt.drawFrame(
        "vc2CityVoid",
        BASE_FRAMES.sidewalk,
        tx * TILE_SIZE,
        ty * TILE_SIZE,
      );
    });
  }

  applyRoadCleanup(rt, tileTypes) {
    ROAD_CLEANUP_RECTS.forEach((rect) => {
      const startTx = Math.floor(rect.x / TILE_SIZE);
      const startTy = Math.floor(rect.y / TILE_SIZE);
      const endTx = Math.ceil((rect.x + rect.width) / TILE_SIZE);
      const endTy = Math.ceil((rect.y + rect.height) / TILE_SIZE);

      for (let ty = startTy; ty < endTy; ty += 1) {
        for (let tx = startTx; tx < endTx; tx += 1) {
          if (!tileTypes[ty] || tileTypes[ty][tx] === "void") continue;
          tileTypes[ty][tx] = "road";
          rt.drawFrame(
            "vc2CityVoid",
            BASE_FRAMES.road,
            tx * TILE_SIZE,
            ty * TILE_SIZE,
          );
        }
      }
    });
  }

  isInsideSimpleBuilding(x, y) {
    return (
      SIMPLE_BUILDINGS.some((building) => {
        const width = building.widthTiles * TILE_SIZE;
        const height = (building.roofRows + building.baseRows) * TILE_SIZE;
        return (
          x >= building.x
          && x < building.x + width
          && y >= building.y
          && y < building.y + height
        );
      })
      || CUSTOM_BUILDINGS.some((building) => (
        x >= building.x
        && x < building.x + building.width
        && y >= building.y
        && y < building.y + building.height
      ))
    );
  }

  fillRectWithFrame(rt, textureKey, frame, x, y, width, height) {
    for (let py = y; py < y + height; py += TILE_SIZE) {
      for (let px = x; px < x + width; px += TILE_SIZE) {
        rt.drawFrame(textureKey, frame, px, py);
      }
    }
  }

  update() {
    this.syncStoryEncounterRuntime();
    this.syncWhisperingForestPortalVisual();
    this.syncStoryWorldTriggerSensor();

    if (
      typeof window !== "undefined" &&
      (
        window.__storySceneInputLocked ||
        window.__storyWorldEncounterPaused
      )
    ) {
      this.setNpcInteractionTarget(null);
      this.player.setVelocity(0, 0);
      this.player.setDepth(PLAYER_DEPTH);
      this.player.anims?.stop?.();
      syncStoryCompanionFollower(this, this.storyCompanionFollower, {
        direction: this.lastFacingDirection,
      });
      return;
    }

    const speed = 2;
    let vx = 0;
    let vy = 0;
    const { x: jx, y: jy } = this.joystick;

    if (jx || jy) {
      vx = jx * speed;
      vy = jy * speed;
    } else {
      if (this.cursors.left.isDown || this.keys.A.isDown) vx = -speed;
      else if (this.cursors.right.isDown || this.keys.D.isDown) vx = speed;
      if (this.cursors.up.isDown || this.keys.W.isDown) vy = -speed;
      else if (this.cursors.down.isDown || this.keys.S.isDown) vy = speed;
    }

    if (vx && vy) {
      if (Math.abs(vx) >= Math.abs(vy)) {
        vy = 0;
      } else {
        vx = 0;
      }
    }

    this.player.setVelocity(vx, vy);
    this.player.setDepth(PLAYER_DEPTH);
    this.updateCityPatrolNpcs();
    this.updateStoryEncounterSprites();

    if (this.playerDebugGfx && this.player?.body?.bounds) {
      const bounds = this.player.body.bounds;
      const width = bounds.max.x - bounds.min.x;
      const height = bounds.max.y - bounds.min.y;

      this.playerDebugGfx.clear();
      this.playerDebugGfx.lineStyle(2, 0x7bf1a8, 0.95);
      this.playerDebugGfx.fillStyle(0x7bf1a8, 0.12);
      this.playerDebugGfx.strokeRect(bounds.min.x, bounds.min.y, width, height);
      this.playerDebugGfx.fillRect(bounds.min.x, bounds.min.y, width, height);
    }

    if (
      updateLocalOrbAvatar(
        this,
        this.player,
        this.playerOrbImage,
        this.localOrbAvatarData,
        {
          x: this.player.x,
          y: this.player.y,
          vx,
          depth: PLAYER_DEPTH,
        },
      )
    ) {
      // Orb avatars use the image overlay instead of the walking spritesheet.
    } else if (Math.abs(vy) > Math.abs(vx)) {
      if (vy < 0) this.player.anims.play("walk-up", true);
      else if (vy > 0) this.player.anims.play("walk-down", true);
    } else if (vx < 0) {
      this.player.anims.play("walk-left", true);
    } else if (vx > 0) {
      this.player.anims.play("walk-right", true);
    } else {
      this.player.anims.stop();
    }

    const direction =
      vx < 0
        ? 270
        : vx > 0
          ? 90
          : vy < 0
            ? 180
            : vy > 0
              ? 0
              : null;
    if (direction !== null) {
      this.lastFacingDirection = direction;
    }

    syncStoryCompanionFollower(this, this.storyCompanionFollower, {
      vx,
      vy,
      direction: this.lastFacingDirection,
    });

    if (this.playersFromReact) {
      const { players = {}, selfId } = this.playersFromReact;
      const localId = selfId || this.selfId || this.userData?.id;
      const currentPlayerRaw = players?.[localId] || {
        world: this.userData?.world || "Void City",
        building: "",
      };
      const currentWorld = currentPlayerRaw?.world ?? this.userData?.world ?? "Void City";
      const currentBuilding = currentPlayerRaw?.building ?? "";

      this.playersFromReact = null;

      Object.entries(players).forEach(([uid, p]) => {
        const playerWorld = p?.world ?? "Void City";
        const playerBuilding = p?.building ?? "";
        if (
          !p ||
          uid === localId ||
          typeof p.x !== "number" ||
          typeof p.y !== "number" ||
          playerWorld !== currentWorld ||
          playerBuilding !== currentBuilding
        ) {
          return;
        }

        const avatarData = resolveAvatarData(p);
        const avatarKey = normalizeAvatarName(p?.avatar?.name || "io_default");
        const spriteKey = `avatar-${avatarKey}`;
        const customOrbTextureKey =
          avatarData.isOrbAvatar && avatarData.usesStaticImageOverlay
            ? createOrbTextureKey(
                p?.orbAvatar || { tokenId: p?.id || avatarData.normalizedName },
              )
            : null;
        const existing = this.remotePlayers[uid];

        if (avatarData.isOrbAvatar && avatarData.usesStaticImageOverlay && !this.textures.exists(customOrbTextureKey)) {
          this.ensureOrbTexture(p).catch((error) => {
            console.warn("Failed to load remote orb avatar texture:", error);
          });
          return;
        }

        if (!existing) {
          const sprite = this.add
            .sprite(
              p.x,
              p.y,
              avatarData.isOrbAvatar && avatarData.usesStaticImageOverlay ? "avatar-io_default" : spriteKey,
              0,
            )
            .setAlpha(avatarData.isOrbAvatar && avatarData.usesStaticImageOverlay ? 0 : 0.82)
            .setDepth(p.y + 24);

          const spriteConfig = getAvatarSpriteConfig(avatarKey);
          sprite.setScale(spriteConfig.worldScale || 1);
          if (spriteConfig.trimBottom) {
            sprite.setCrop(
              0,
              0,
              spriteConfig.frameWidth,
              spriteConfig.frameHeight - spriteConfig.trimBottom,
            );
          }

          const orbImage =
            avatarData.isOrbAvatar && avatarData.usesStaticImageOverlay
              ? this.add
                  .image(p.x, p.y, customOrbTextureKey)
                  .setDisplaySize(ORB_RENDER_SIZE, ORB_RENDER_SIZE)
                  .setDepth(p.y + 24)
                  .setAlpha(0.92)
              : null;

          const nameTagBg = this.add.graphics().setDepth(p.y + 26);
          const nameTag = this.add
            .text(p.x, p.y - REMOTE_PLAYER_NAME_OFFSET_Y, `${p.name || "Unknown"}`, {
              font: "12px Arial",
              fill: "#ffffff",
              stroke: "#000000",
              strokeThickness: 3,
            })
            .setOrigin(0.5, 1)
            .setDepth(p.y + 27);

          this.remotePlayers[uid] = { sprite, orbImage, nameTag, nameTagBg };
        }

        const remote = this.remotePlayers[uid];
        remote.sprite?.setPosition(p.x, p.y).setDepth(p.y + 24);
        remote.orbImage?.setPosition(p.x, p.y).setDepth(p.y + 24);
        remote.nameTag?.setPosition(p.x, p.y - REMOTE_PLAYER_NAME_OFFSET_Y).setDepth(p.y + 27);
        remote.nameTag?.setText(`${p.name || "Unknown"}`);
        remote.nameTagBg?.setDepth(p.y + 26);

        if (remote.nameTag && remote.nameTagBg) {
          const padding = 6;
          const textWidth = remote.nameTag.width;
          const textHeight = remote.nameTag.height;
          remote.nameTagBg.clear();
          remote.nameTagBg.fillStyle(0x000000, 0.5);
          remote.nameTagBg.fillRoundedRect(
            p.x - textWidth / 2 - padding,
            p.y - REMOTE_PLAYER_NAME_OFFSET_Y - textHeight - padding,
            textWidth + padding * 2,
            textHeight + padding * 2,
            8,
          );
        }

        if (remote.sprite && !(avatarData.isOrbAvatar && avatarData.usesStaticImageOverlay)) {
          const frameOffset =
            p.animState === "walking" ? (((Date.now() % 400) / 100) | 0) : 0;
          remote.sprite.setFrame(
            getAvatarFrameForDirection(
              p?.avatar?.name || "io_default",
              p.direction,
              frameOffset,
            ),
          );
        }
      });

      Object.keys(this.remotePlayers).forEach((uid) => {
        const p = players?.[uid];
        const playerWorld = p?.world ?? "Void City";
        const playerBuilding = p?.building ?? "";
        if (
          !p ||
          uid === localId ||
          playerWorld !== currentWorld ||
          playerBuilding !== currentBuilding
        ) {
          destroyRemotePlayerVisual(this.remotePlayers[uid]);
          delete this.remotePlayers[uid];
        }
      });
    }

    const onLocalMove =
      typeof window !== "undefined" ? window.__voidCityOnLocalMove : null;
    if (typeof onLocalMove === "function") {
      const animState = vx === 0 && vy === 0 ? "idle" : "walking";
      const shouldBroadcast =
        this.player.x !== this.lastBroadcast.x ||
        this.player.y !== this.lastBroadcast.y ||
        direction !== this.lastBroadcast.direction ||
        animState !== this.lastBroadcast.animState;

      if (shouldBroadcast) {
        this.lastBroadcast = {
          x: this.player.x,
          y: this.player.y,
          direction,
          animState,
        };
        onLocalMove(this.player.x, this.player.y, direction ?? 0, animState);
      }
    }
  }
}
